import React from 'react';
const O = React.Fragment;

/* This is your translations file. It is automatically updated by `traks update`
 * which parses and rewrites it, potentially adding new translations and
 * updating underscore-prefixed fields, to reflect changes in your main source.
 * To avoid nasty surprises you should follow these guidelines:
 *  - Everything before the export statement is rewritten as-is; you can add
 *    imports, functions and whatever you like here.
 *  - Everything inside the export statement, except for function bodies, is
 *    _rebuilt_. If you change anything here, then at best it will be overwritten
 *    by `traks update` (this includes writing comments), and at worst, it might
 *    cause `traks update` to consider the file corrupt, and thus refuse to
 *    update it.
 *  - One exception is hash-prefixed keys, e.g. "#comment"; you can add these
 *    before underscore-prefixed fields and they'll be preserved. You can use
 *    these for your own needs, e.g. commenting on translations.
 *  - Function bodies can be in block-statement form, or in expression form.
 *    That is, both these examples are valid (and equivalent):
 *       "en": () => {
 *           return <O>Hello world!</O>
 *       },
 *       "en": () => <O>Hello world!</O>,
 *    Also, `traks update` will not meddle with this once a translation is there,
 *    so you can convert between these two styles as you wish. New translations are
 *    added in expression form if they're one-liners.
 *  - It's a good idea to run `traks update` before you commit since it verifies
 *    that the file is valid, and it might change formatting and update
 *    underscore-prefixed fields.
 *
 * See also the import file (./src/traks.js) for more info on usage.
 */
// eslint-disable-next-line
export default {
	"068cd3a4c507": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> Indtast dit brugernavn (e-mail). Hvis der findes en konto i vores system, vil et link til nulstilling af adgangskode blive sendt til dig via e-mail.</O>,
		"de": () => <O>Enter your username (email). If an account exists in our system, a reset password link will be emailed to you.</O>,
		"en": () => <O>Enter your username (email). If an account exists in our system, a reset password link will be emailed to you.</O>,
		"no": () => <O>Enter your username (email). If an account exists in our system, a reset password link will be emailed to you.</O>,
		"sv": () => <O>Enter your username (email). If an account exists in our system, a reset password link will be emailed to you.</O>,
	},

	"57c96be48e3f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Nulstil adgangskode</O>,
		"de": () => <O>Reset Password</O>,
		"en": () => <O>Reset Password</O>,
		"no": () => <O>Reset Password</O>,
		"sv": () => <O>Reset Password</O>,
	},

	"974df8c1f5c2": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>En email er blevet sendt, se din indbakke!</O>,
		"de": () => <O>An email has been sent. Please check your mail!</O>,
		"en": () => <O>An email has been sent. Please check your mail!</O>,
		"no": () => <O>An email has been sent. Please check your mail!</O>,
		"sv": () => <O>An email has been sent. Please check your mail!</O>,
	},

	"5ff40b1157ce": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilbage til login?</O>,
		"de": () => <O>Back to login?</O>,
		"en": () => <O>Back to login?</O>,
		"no": () => <O>Back to login?</O>,
		"sv": () => <O>Back to login?</O>,
	},

	"182bfd87150e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Slet adgang til indberening</O>,
		"de": () => <O>Delete Entry Access</O>,
		"en": () => <O>Delete Entry Access</O>,
		"no": () => <O>Delete Entry Access</O>,
		"sv": () => <O>Delete Entry Access</O>,
	},

	"4065ac5bd85f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> Er du sikker på, at du vil slette denne adgang?</O>,
		"de": () => <O>Are you sure you want to delete this entry access?</O>,
		"en": () => <O>Are you sure you want to delete this entry access?</O>,
		"no": () => <O>Are you sure you want to delete this entry access?</O>,
		"sv": () => <O>Are you sure you want to delete this entry access?</O>,
	},

	"f3f8bd0389ab": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Aldrig</O>,
		"de": () => <O>Never</O>,
		"en": () => <O>Never</O>,
		"no": () => <O>Never</O>,
		"sv": () => <O>Never</O>,
	},

	"f524290494dd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kaldenavn</O>,
		"de": () => <O>Screen Name</O>,
		"en": () => <O>Screen Name</O>,
		"no": () => <O>Screen Name</O>,
		"sv": () => <O>Screen Name</O>,
	},

	"e71187b9209b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus er en sikker og intuitiv løsning -
                                        bliv klar inden den 17. december.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Pentus is a safe and intuitive solution -
                                        get ready before December 17th.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Pentus is a safe and intuitive solution -
                                        get ready before December 17th.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Pentus is a safe and intuitive solution -
                                        get ready before December 17th.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Pentus is a safe and intuitive solution -
                                        get ready before December 17th.
                                </O>
                        );
                },
	},

	"07c6ee4721a4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus whistleblower-software er en innovativ og sikker platform designet til at styrke personer til at
                                        rapportere uetisk adfærd, misforhold og overtrædelser af overholdelse inden for organisationer.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Pentus whistleblower-software is an innovative and secure platform designed to empower
                                        individuals to report unethical behavior, discrepancies, and compliance violations within
                                        organizations.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Pentus whistleblower-software is an innovative and secure platform designed to empower
                                        individuals to report unethical behavior, discrepancies, and compliance violations within
                                        organizations.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Pentus whistleblower-software is an innovative and secure platform designed to empower
                                        individuals to report unethical behavior, discrepancies, and compliance violations within
                                        organizations.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Pentus whistleblower-software is an innovative and secure platform designed to empower
                                        individuals to report unethical behavior, discrepancies, and compliance violations within
                                        organizations.
                                </O>
                        );
                },
	},

	"e822376ba990": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus er en brugervenlig, webbaseret applikation designet til at lette anonym rapportering af bekymringer og
                                        hændelser inden for organisationer. Vores platform prioriterer fortrolighed og sikkerhed for at sikre, at
                                        whistleblowere kan rapportere hændelser uden frygt for gengældelse.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Pentus is a user-friendly, web-based application designed to facilitate anonymous
                                        reporting of concerns and incidents within organizations. Our platform prioritizes
                                        confidentiality and security to ensure that whistleblowers can report incidents without
                                        fear of retaliation.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Pentus is a user-friendly, web-based application designed to facilitate anonymous
                                        reporting of concerns and incidents within organizations. Our platform prioritizes
                                        confidentiality and security to ensure that whistleblowers can report incidents without
                                        fear of retaliation.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Pentus is a user-friendly, web-based application designed to facilitate anonymous
                                        reporting of concerns and incidents within organizations. Our platform prioritizes
                                        confidentiality and security to ensure that whistleblowers can report incidents without
                                        fear of retaliation.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Pentus is a user-friendly, web-based application designed to facilitate anonymous
                                        reporting of concerns and incidents within organizations. Our platform prioritizes
                                        confidentiality and security to ensure that whistleblowers can report incidents without
                                        fear of retaliation.
                                </O>
                        );
                },
	},

	"d0252e577a78": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvordan foretager jeg en indberetning?</O>,
		"de": () => <O>How do I submit a entry?</O>,
		"en": () => <O>How do I submit a entry?</O>,
		"no": () => <O>How do I submit a entry?</O>,
		"sv": () => <O>How do I submit a entry?</O>,
	},

	"153fa30819d6": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Enhver, der har adgang til nedenstående link, kan indsende en indberetning. Du kan ændre dette link under virksomhedsindstillinger, hvis du er administrator. videregiv linket til dem, der skal kunne indsende sager.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Anyone who has access to the link below can submit an entry. You can change this link under company settings
                                        if you are an admin. Distribute it to those who are supposed to be able to submit cases.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Anyone who has access to the link below can submit an entry. You can change this link under company settings
                                        if you are an admin. Distribute it to those who are supposed to be able to submit cases.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Anyone who has access to the link below can submit an entry. You can change this link under company settings
                                        if you are an admin. Distribute it to those who are supposed to be able to submit cases.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Anyone who has access to the link below can submit an entry. You can change this link under company settings
                                        if you are an admin. Distribute it to those who are supposed to be able to submit cases.
                                </O>
                        );
                },
	},

	"a909231f0d9a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvem har adgang til indberetningerne?</O>,
		"de": () => <O>Who has access to the entries?</O>,
		"en": () => <O>Who has access to the entries?</O>,
		"no": () => <O>Who has access to the entries?</O>,
		"sv": () => <O>Who has access to the entries?</O>,
	},

	"21d8d57caf92": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Kun sagsbehandleren, som er tildelt indberetningen, har adgang til indholdet af indberetningen. Dette er for at beskytte whistlebloweren og for at sikre, at adgangen er begrænset til så få personer som muligt.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Only the caseworker assigned to the entry has access to content of the entry. This is in order to protect the wistleblower, and
                                        to make sure, that access is limited to as few people as possible
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Only the caseworker assigned to the entry has access to content of the entry. This is in order to protect the whistleblower, and 					to make sure, that access is limited to as few people as possible
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Only the caseworker assigned to the entry has access to content of the entry. This is in order to protect the wistleblower, and
                                        to make sure, that access is limited to as few people as possible
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Only the caseworker assigned to the entry has access to content of the entry. This is in order to protect the wistleblower, and
                                        to make sure, that access is limited to as few people as possible
                                </O>
                        );
                },
	},

	"28b42687d40e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvordan kommunikerer jeg med indbereteren?</O>,
		"de": () => <O>How do I communicate with the entry creator?</O>,
		"en": () => <O>How do I communicate with the entry creator?</O>,
		"no": () => <O>How do I communicate with the entry creator?</O>,
		"sv": () => <O>How do I communicate with the entry creator?</O>,
	},

	"9945e722aab4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Den tildelte sagsbehandler kan sende beskeder til sagens indberetter. Hvis indbereteren ikke er anonym, vil indbereteren blive underrettet, ellers skal indbereteren aktivt tjekke for aktivitet på deres sag.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        The assigned caseworker is able to send messages to the case reporteer. If the case reporter is not anonymous,
                                        the case reporter is notified, otherwise the case reporter must actively check for activity on their case.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        The assigned caseworker is able to send messages to the case reporteer. If the case reporter is not anonymous,
                                        the case reporter is notified, otherwise the case reporter must actively check for activity on their case.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        The assigned caseworker is able to send messages to the case reporteer. If the case reporter is not anonymous,
                                        the case reporter is notified, otherwise the case reporter must actively check for activity on their case.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        The assigned caseworker is able to send messages to the case reporteer. If the case reporter is not anonymous,
                                        the case reporter is notified, otherwise the case reporter must actively check for activity on their case.
                                </O>
                        );
                },
	},

	"2e755dcce2ae": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvem vil blive tildelt sagen, når den er indsendt?</O>,
		"de": () => <O>Who will be assigned to the case once submitted?</O>,
		"en": () => <O>Who will be assigned to the case once submitted?</O>,
		"no": () => <O>Who will be assigned to the case once submitted?</O>,
		"sv": () => <O>Who will be assigned to the case once submitted?</O>,
	},

	"0d8429bf5b4b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Når nogen opretter en sag, skal de også vælge, hvem der skal tildeles sagen. En liste præsenteres med forskellige muligheder for, hvem der kan tildeles sagen. Om en bruger er en mulighed for sagens opretter, kan indstilles for hver bruger.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        When someone creates a case, they must also choose who to assign the case to. A list will be presented with
                                        the different options for who will be assigned to the case. Whether a user is an option for the case creator
                                        can be set under each user.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        When someone creates a case, they must also choose who to assign the case to. A list will be presented with
                                        the different options for who will be assigned to the case. Whether a user is an option for the case creator
                                        can be set under each user.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        When someone creates a case, they must also choose who to assign the case to. A list will be presented with
                                        the different options for who will be assigned to the case. Whether a user is an option for the case creator
                                        can be set under each user.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        When someone creates a case, they must also choose who to assign the case to. A list will be presented with
                                        the different options for who will be assigned to the case. Whether a user is an option for the case creator
                                        can be set under each user.
                                </O>
                        );
                },
	},

	"5c3ee88ccb49": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvad er forskellen på en intern bruger og en ekstern bruger?</O>,
		"de": () => <O>What is the difference on an internal user and a external user?</O>,
		"en": () => <O>What is the difference on an internal user and a external user?</O>,
		"no": () => <O>What is the difference on an internal user and a external user?</O>,
		"sv": () => <O>What is the difference on an internal user and a external user?</O>,
	},

	"eb495c315b97": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        De interne brugere vil ofte være personer inden for din egen virksomhed. Disse vil ofte være sagsbehandlerne, der vil håndtere sagerne og sørge for, at de bliver behandlet i overensstemmelse med loven. Eksterne brugere er derimod tredjepartsagenter, der kan assistere i sager, hvor omstændighederne kræver det.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        The internal user(s) will most often be someone inside your own company. These will often be the
                                        caseworkers who will manage the cases and make sure they will be handled, following the laws.
                                        External users are, on the other hand, 3rd party agents, who can assist in cases where the
                                        circumstances requires it.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        The internal user(s) will most often be someone inside your own company. These will often be the
                                        caseworkers who will manage the cases and make sure they will be handled, following the laws.
                                        External users are, on the other hand, 3rd party agents, who can assist in cases where the
                                        circumstances requires it.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        The internal user(s) will most often be someone inside your own company. These will often be the
                                        caseworkers who will manage the cases and make sure they will be handled, following the laws.
                                        External users are, on the other hand, 3rd party agents, who can assist in cases where the
                                        circumstances requires it.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        The internal user(s) will most often be someone inside your own company. These will often be the
                                        caseworkers who will manage the cases and make sure they will be handled, following the laws.
                                        External users are, on the other hand, 3rd party agents, who can assist in cases where the
                                        circumstances requires it.
                                </O>
                        );
                },
	},

	"e36b1a29986b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kan jeg give midlertidig adgang til en indberetning til nogen uden for systemet?</O>,
		"de": () => <O>Can I give temporary access to an entry to someone outside the system?</O>,
		"en": () => <O>Can I give temporary access to an entry to someone outside the system?</O>,
		"no": () => <O>Can I give temporary access to an entry to someone outside the system?</O>,
		"sv": () => <O>Can I give temporary access to an entry to someone outside the system?</O>,
	},

	"f31c2fc32b8c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Ja, en administrator eller den tildelte sagsbehandler kan midlertidigt dele indberetningen ved at oprette et link, der udløber efter en vis tid. Modtageren af linket skal gennemføre to-faktor-godkendelse, før de kan få adgang til indberetningen.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Yes, An admin or the assigned caseworker can share the entry temporarily through creating a link, that will
                                        expire after some time. The reciever of the link must be two-factor authenticated upon accessing it.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Yes, An admin or the assigned caseworker can share the entry temporarily through creating a link, that will
                                        expire after some time. The reciever of the link must be two-factor authenticated upon accessing it.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Yes, An admin or the assigned caseworker can share the entry temporarily through creating a link, that will
                                        expire after some time. The reciever of the link must be two-factor authenticated upon accessing it.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Yes, An admin or the assigned caseworker can share the entry temporarily through creating a link, that will
                                        expire after some time. The reciever of the link must be two-factor authenticated upon accessing it.
                                </O>
                        );
                },
	},

	"a9d92e30aaaa": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tak for din besked.</O>,
		"de": () => <O>Thank you for your message.</O>,
		"en": () => <O>Thank you for your message.</O>,
		"no": () => <O>Thank you for your message.</O>,
		"sv": () => <O>Thank you for your message.</O>,
	},

	"a3bde6c840cf": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vi vender tilbage til dig så hurtigt som muligt</O>,
		"de": () => <O>We will get back to you as soon as possible.</O>,
		"en": () => <O>We will get back to you as soon as possible.</O>,
		"no": () => <O>We will get back to you as soon as possible.</O>,
		"sv": () => <O>We will get back to you as soon as possible.</O>,
	},

	"05cd5066ab54": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kom i gang hurtigt og nemt</O>,
		"de": () => <O>Get started quickly and easy</O>,
		"en": () => <O>Get started quickly and easy</O>,
		"no": () => <O>Get started quickly and easy</O>,
		"sv": () => <O>Get started quickly and easy</O>,
	},

	"160f53454f0e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Lad os kontakte dig, så vi kan fortælle dig hvordan Pentus
                                        kan hjælpe præcist dit firma. Det er nemt, og opsætningen er hurtig.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Let us contact you so we can tell you how Pentus can help
                                        precisely your company. It's easy and setting it up is fast.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Let us contact you so we can tell you how Pentus can help
                                        precisely your company. It's easy and setting it up is fast.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Let us contact you so we can tell you how Pentus can help
                                        precisely your company. It's easy and setting it up is fast.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Let us contact you so we can tell you how Pentus can help
                                        precisely your company. It's easy and setting it up is fast.
                                </O>
                        );
                },
	},

	"94d38e0dc1d3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Du kan ringe til os direkte på +45 33 11 19 00</O>,
		"de": () => <O>You can also call us directly on +45 33 11 19 00</O>,
		"en": () => <O>You can also call us directly on +45 33 11 19 00</O>,
		"no": () => <O>You can also call us directly on +45 33 11 19 00</O>,
		"sv": () => <O>You can also call us directly on +45 33 11 19 00</O>,
	},

	"516d450dd4e3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Book din demo idag</O>,
		"de": () => <O>Book your demo today</O>,
		"en": () => <O>Book your demo today</O>,
		"no": () => <O>Book your demo today</O>,
		"sv": () => <O>Book your demo today</O>,
	},

	"51406c82dc2f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Udfyld formularen og vi kontakter dig med en online demonstration af Pentus.<br />
                                        Efter din demo kan du teste Pentus <span className="fw_700">GRATIS</span> i 14 dage!
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Fill out the form and we'll contact your for a demo of Pentus.<br />
                                        You can test Pentus <span className="fw_700">FOR FREE</span> for 14 days after the demo!
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Fill out the form and we'll contact your for a demo of Pentus.<br />
                                        You can test Pentus <span className="fw_700">FOR FREE</span> for 14 days after the demo!
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Fill out the form and we'll contact your for a demo of Pentus.<br />
                                        You can test Pentus <span className="fw_700">FOR FREE</span> for 14 days after the demo!
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Fill out the form and we'll contact your for a demo of Pentus.<br />
                                        You can test Pentus <span className="fw_700">FOR FREE</span> for 14 days after the demo!
                                </O>
                        );
                },
	},

	"2aafa7ddc337": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Dit navn</O>,
		"de": () => <O>Your name</O>,
		"en": () => <O>Your name</O>,
		"no": () => <O>Your name</O>,
		"sv": () => <O>Your name</O>,
	},

	"fd66b11f49c2": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Firmanavn</O>,
		"de": () => <O>Company name</O>,
		"en": () => <O>Company name</O>,
		"no": () => <O>Company name</O>,
		"sv": () => <O>Company name</O>,
	},

	"fc30f8f6c7a9": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Sikkert at bruge</O>,
		"de": () => <O>Safe To Use</O>,
		"en": () => <O>Safe To Use</O>,
		"no": () => <O>Safe To Use</O>,
		"sv": () => <O>Safe To Use</O>,
	},

	"a01323891355": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus sikrer jer fuld overholdelse af EU whistleblowerdirektivet på en overskuelig, effektiv og
                                        sikker måde. Så kan I få tid til at drive jeres forretning.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Pentus ensures your company full compliance with the EU
                                        whistleblower directive, in a secure, intuitive and comprehensible
                                        way, leaving you time to run your business.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Pentus ensures your company full compliance with the EU
                                        whistleblower directive, in a secure, intuitive and comprehensible
                                        way, leaving you time to run your business.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Pentus ensures your company full compliance with the EU
                                        whistleblower directive, in a secure, intuitive and comprehensible
                                        way, leaving you time to run your business.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Pentus ensures your company full compliance with the EU
                                        whistleblower directive, in a secure, intuitive and comprehensible
                                        way, leaving you time to run your business.
                                </O>
                        );
                },
	},

	"fa5adeb830ae": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>256-bit kryptering</O>,
		"de": () => <O>256-bit encryption</O>,
		"en": () => <O>256-bit encryption</O>,
		"no": () => <O>256-bit encryption</O>,
		"sv": () => <O>256-bit encryption</O>,
	},

	"b3fae1f5148b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>Alle indberetninger samt sagsbehandling er sikret af 256-bit kryptering. Anonymitet og fortrolighed er i
                                        de bedste hænder.</O>
                        );
                },
		"de": () => {
                        return (
                                <O>Industry grade encryption used everywhere. Anonymity and
                                        confidence is in the best hands.</O>
                        );
                },
		"en": () => {
                        return (
                                <O>Industry grade encryption used everywhere. Anonymity and
                                        confidence is in the best hands.</O>
                        );
                },
		"no": () => {
                        return (
                                <O>Industry grade encryption used everywhere. Anonymity and
                                        confidence is in the best hands.</O>
                        );
                },
		"sv": () => {
                        return (
                                <O>Industry grade encryption used everywhere. Anonymity and
                                        confidence is in the best hands.</O>
                        );
                },
	},

	"f1aac0cf1eb2": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>ISO27001-fokus</O>,
		"de": () => <O>ISO27001 focus</O>,
		"en": () => <O>ISO27001 focus</O>,
		"no": () => <O>ISO27001 focus</O>,
		"sv": () => <O>ISO27001 focus</O>,
	},

	"3b2f31bab710": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>Certificeret databeskyttelse og cyberresiliens er sikret med disse standarder,
                                        som vi har fuldt fokus på at overholde.</O>
                        );
                },
		"de": () => {
                        return (
                                <O>Certified data protection and cyber resilience is ensured
                                        with these standards that we aim to fully comply with.</O>
                        );
                },
		"en": () => {
                        return (
                                <O>Certified data protection and cyber resilience is ensured
                                        with these standards that we aim to fully comply with.</O>
                        );
                },
		"no": () => {
                        return (
                                <O>Certified data protection and cyber resilience is ensured
                                        with these standards that we aim to fully comply with.</O>
                        );
                },
		"sv": () => {
                        return (
                                <O>Certified data protection and cyber resilience is ensured
                                        with these standards that we aim to fully comply with.</O>
                        );
                },
	},

	"74818c2a3e32": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>GDPR Compliant</O>,
		"de": () => <O>GDPR Compliant</O>,
		"en": () => <O>GDPR Compliant</O>,
		"no": () => <O>GDPR Compliant</O>,
		"sv": () => <O>GDPR Compliant</O>,
	},

	"68cbc91d3e04": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus sikrer total overholdelse af persondatalovgivningen i Danmark. Fuldt customiserbare flows og tofaktorgodkendelse.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Pentus ensures total compliance with the personal data legislation
                                        in Denmark. Fully customisable flows and two-factor authorization.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Pentus ensures total compliance with the personal data legislation
                                        in Denmark. Fully customisable flows and two-factor authorization.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Pentus ensures total compliance with the personal data legislation
                                        in Denmark. Fully customisable flows and two-factor authorization.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Pentus ensures total compliance with the personal data legislation
                                        in Denmark. Fully customisable flows and two-factor authorization.
                                </O>
                        );
                },
	},

	"702fea4a35f1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvorfor skal du vælge Pentus?</O>,
		"de": () => <O>Why should you choose Pentus?</O>,
		"en": () => <O>Why should you choose Pentus?</O>,
		"no": () => <O>Why should you choose Pentus?</O>,
		"sv": () => <O>Why should you choose Pentus?</O>,
	},

	"e82a52304809": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Markedets billigste løsning
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Most competetive pricing in the market
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Most competetive pricing in the market
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Most competetive pricing in the market
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Most competetive pricing in the market
                                </O>
                        );
                },
	},

	"30ab484c1843": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Fuld overholdelse af EU-Whistleblower direktivet
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Full compliance with the EU-directive
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Full compliance with the EU-directive
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Full compliance with the EU-directive
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Full compliance with the EU-directive
                                </O>
                        );
                },
	},

	"b7cb83f7ccf8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        100% fortroligt og anonymt
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        100% confidentiality and anonymous
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        100% confidentiality and anonymous
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        100% confidentiality and anonymous
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        100% confidentiality and anonymous
                                </O>
                        );
                },
	},

	"cafb5efc473d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Book din demo</O>,
		"de": () => <O>Book your demo</O>,
		"en": () => <O>Book your demo</O>,
		"no": () => <O>Book your demo</O>,
		"sv": () => <O>Book your demo</O>,
	},

	"c12866b85ce5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Dine data bliver i EU</O>,
		"de": () => <O>Your data stays in the EU</O>,
		"en": () => <O>Your data stays in the EU</O>,
		"no": () => <O>Your data stays in the EU</O>,
		"sv": () => <O>Your data stays in the EU</O>,
	},

	"f4ff2fb44f64": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>Pentus er udviklet af danske programmører og rådgivere i Danmark. Al data ligger -- og bliver liggende --
                                        på EU-servere.</O>
                        );
                },
		"de": () => {
                        return (
                                <O>Pentus is made in Denmark and all data is located on -- and will
                                        never leave -- servers in the EU</O>
                        );
                },
		"en": () => {
                        return (
                                <O>Pentus is made in Denmark and all data is located on -- and will
                                        never leave -- servers in the EU</O>
                        );
                },
		"no": () => {
                        return (
                                <O>Pentus is made in Denmark and all data is located on -- and will
                                        never leave -- servers in the EU</O>
                        );
                },
		"sv": () => {
                        return (
                                <O>Pentus is made in Denmark and all data is located on -- and will
                                        never leave -- servers in the EU</O>
                        );
                },
	},

	"44bb1fd6eeda": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Brugergrænseflade på dansk og engelsk</O>,
		"de": () => <O>User interface in Danish and English</O>,
		"en": () => <O>User interface in Danish and English</O>,
		"no": () => <O>User interface in Danish and English</O>,
		"sv": () => <O>User interface in Danish and English</O>,
	},

	"37fd74b8ca23": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Sikker kommunikation med 256-bit kryptering</O>,
		"de": () => <O>Safe communication with 256-bit encryption</O>,
		"en": () => <O>Safe communication with 256-bit encryption</O>,
		"no": () => <O>Safe communication with 256-bit encryption</O>,
		"sv": () => <O>Safe communication with 256-bit encryption</O>,
	},

	"adcb0e976811": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Firma-branding med logo</O>,
		"de": () => <O>Company branding with logo</O>,
		"en": () => <O>Company branding with logo</O>,
		"no": () => <O>Company branding with logo</O>,
		"sv": () => <O>Company branding with logo</O>,
	},

	"23a04f73aeaf": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Indledende personlig screening af op til 5 indberetninger om året af <a target="_blank" rel="noopener noreferrer" alt="raadgiver.dk" href="https://raadgiver.dk">
                                                Raadgiver.dk</a> ApS.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Initial personal screening of up to 5 cases per year by
                                        corporate law consulting company, <a target="_blank"
                                                rel="noopener noreferrer" alt="raadgiver.dk"
                                                href="https://raadgiver.dk">R&sect;&sect;dgiver.dk</a> ApS
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Initial personal screening of up to 5 cases per year by
                                        corporate law consulting company, <a target="_blank"
                                                rel="noopener noreferrer" alt="raadgiver.dk"
                                                href="https://raadgiver.dk">R&sect;&sect;dgiver.dk</a> ApS
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Initial personal screening of up to 5 cases per year by
                                        corporate law consulting company, <a target="_blank"
                                                rel="noopener noreferrer" alt="raadgiver.dk"
                                                href="https://raadgiver.dk">R&sect;&sect;dgiver.dk</a> ApS
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Initial personal screening of up to 5 cases per year by
                                        corporate law consulting company, <a target="_blank"
                                                rel="noopener noreferrer" alt="raadgiver.dk"
                                                href="https://raadgiver.dk">R&sect;&sect;dgiver.dk</a> ApS
                                </O>
                        );
                },
	},

	"777529adf594": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Betydelig rabat, hvis du skal bruge assistance fra erhvervsjurister
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Significant discount when further assistance needs to be added
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Significant discount when further assistance needs to be added
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Significant discount when further assistance needs to be added
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Significant discount when further assistance needs to be added
                                </O>
                        );
                },
	},

	"1510a270036f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>PREMIUM</O>,
		"de": () => <O>PREMIUM</O>,
		"en": () => <O>PREMIUM</O>,
		"no": () => <O>PREMIUM</O>,
		"sv": () => <O>PREMIUM</O>,
	},

	"6b46c379b4e9": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vil du slette brugeren?</O>,
		"de": () => <O>Do you want to delete the user?</O>,
		"en": () => <O>Do you want to delete the user?</O>,
		"no": () => <O>Do you want to delete the user?</O>,
		"sv": () => <O>Do you want to delete the user?</O>,
	},

	"5cfb98f0140a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Er du sikker på du vil slette brugeren. Denne handling er irreversibel.</O>,
		"de": () => <O>Are you sure you want to delete the user? This action cannot be undone.</O>,
		"en": () => <O>Are you sure you want to delete the user? This action cannot be undone.</O>,
		"no": () => <O>Are you sure you want to delete the user? This action cannot be undone.</O>,
		"sv": () => <O>Are you sure you want to delete the user? This action cannot be undone.</O>,
	},

	"79d12a8a1d66": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Slet</O>,
		"de": () => <O>Delete</O>,
		"en": () => <O>Delete</O>,
		"no": () => <O>Delete</O>,
		"sv": () => <O>Delete</O>,
	},

	"f47ad2f65f63": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Udløb</O>,
		"de": () => <O>Expiration</O>,
		"en": () => <O>Expiration</O>,
		"no": () => <O>Expiration</O>,
		"sv": () => <O>Expiration</O>,
	},

	"d4e9fd3537b1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Optag</O>,
		"de": () => <O>Record</O>,
		"en": () => <O>Record</O>,
		"no": () => <O>Record</O>,
		"sv": () => <O>Record</O>,
	},

	"f0e6fe128466": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Stop</O>,
		"de": () => <O>Stop</O>,
		"en": () => <O>Stop</O>,
		"no": () => <O>Stop</O>,
		"sv": () => <O>Stop</O>,
	},

	"4e8bf53097ad": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Privatlivspolitik</O>,
		"de": () => <O>Privacy Policy</O>,
		"en": () => <O>Privacy Policy</O>,
		"no": () => <O>Privacy Policy</O>,
		"sv": () => <O>Privacy Policy</O>,
	},

	"222e0c39cb17": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Whistleblowerpolitik</O>,
		"de": () => <O>Whistleblower policy</O>,
		"en": () => <O>Whistleblower policy</O>,
		"no": () => <O>Whistleblower policy</O>,
		"sv": () => <O>Whistleblower policy</O>,
	},

	"68867f888d2b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Databehandleraftale</O>,
		"de": () => <O>Data processing agreement</O>,
		"en": () => <O>Data processing agreement</O>,
		"no": () => <O>Data processing agreement</O>,
		"sv": () => <O>Data processing agreement</O>,
	},

	"dfd862420db1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Skriftlig garanti om overholdelse af juridiske krav.</O>,
		"de": () => <O>Written guarantee of compliance with legal requirements</O>,
		"en": () => <O>Written guarantee of compliance with legal requirements</O>,
		"no": () => <O>Written guarantee of compliance with legal requirements</O>,
		"sv": () => <O>Written guarantee of compliance with legal requirements</O>,
	},

	"3d6577746d15": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Artikel 30-fortegnelse</O>,
		"de": () => <O>Article 30 register</O>,
		"en": () => <O>Article 30 register</O>,
		"no": () => <O>Article 30 register</O>,
		"sv": () => <O>Article 30 register</O>,
	},

	"47608118ed34": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kopier link</O>,
		"de": () => <O>Copy Link</O>,
		"en": () => <O>Copy Link</O>,
		"no": () => <O>Copy Link</O>,
		"sv": () => <O>Copy Link</O>,
	},

	"5a5e1c4cd5bb": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Slet link</O>,
		"de": () => <O>Delete Link</O>,
		"en": () => <O>Delete Link</O>,
		"no": () => <O>Delete Link</O>,
		"sv": () => <O>Delete Link</O>,
	},

	"56a91d115f02": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Deaktivér link</O>,
		"de": () => <O>Deactivate Link</O>,
		"en": () => <O>Deactivate Link</O>,
		"no": () => <O>Deactivate Link</O>,
		"sv": () => <O>Deactivate Link</O>,
	},

	"9eb79e04cbd7": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>uger</O>,
		"de": () => <O>weeks</O>,
		"en": () => <O>weeks</O>,
		"no": () => <O>weeks</O>,
		"sv": () => <O>weeks</O>,
	},

	"2fd6102e4038": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>minutter</O>,
		"de": () => <O>minutes</O>,
		"en": () => <O>minutes</O>,
		"no": () => <O>minutes</O>,
		"sv": () => <O>minutes</O>,
	},

	"dd4824d36ddd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>minut</O>,
		"de": () => <O>minute</O>,
		"en": () => <O>minute</O>,
		"no": () => <O>minute</O>,
		"sv": () => <O>minute</O>,
	},

	"f028606b266f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>siden</O>,
		"de": () => <O>ago</O>,
		"en": () => <O>ago</O>,
		"no": () => <O>ago</O>,
		"sv": () => <O>ago</O>,
	},

	"9502fb279a8d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Din indberetning er blevet skabt!</O>,
		"de": () => <O>Your case has been successfully submitted!</O>,
		"en": () => <O>Your case has been successfully submitted!</O>,
		"no": () => <O>Your case has been successfully submitted!</O>,
		"sv": () => <O>Your case has been successfully submitted!</O>,
	},

	"7ce73e161df4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetningen er delt.</O>,
		"de": () => <O>Entry successfully shared</O>,
		"en": () => <O>Entry successfully shared</O>,
		"no": () => <O>Entry successfully shared</O>,
		"sv": () => <O>Entry successfully shared</O>,
	},

	"66cdbe507465": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>indstillinger opdateret</O>,
		"de": () => <O>settings updated</O>,
		"en": () => <O>settings updated</O>,
		"no": () => <O>settings updated</O>,
		"sv": () => <O>settings updated</O>,
	},

	"823ee11a63e4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Anmodningen er sendt. Du vil blive kontaktet af vores salgsteam hurtigst muligt.</O>,
		"de": () => <O>Request sent, you will be contacted by our sales team</O>,
		"en": () => <O>Request sent, you will be contacted by our sales team</O>,
		"no": () => <O>Request sent, you will be contacted by our sales team</O>,
		"sv": () => <O>Request sent, you will be contacted by our sales team</O>,
	},

	"008a61cb9a03": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetning slettet</O>,
		"de": () => <O>Entry deleted</O>,
		"en": () => <O>Entry deleted</O>,
		"no": () => <O>Entry deleted</O>,
		"sv": () => <O>Entry deleted</O>,
	},

	"873662712419": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>En email er blevet sendt</O>,
		"de": () => <O>An email has been sent</O>,
		"en": () => <O>An email has been sent</O>,
		"no": () => <O>An email has been sent</O>,
		"sv": () => <O>An email has been sent</O>,
	},

	"c8766ae3b041": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> din adgangskode blev nulstillet. </O>,
		"de": () => <O>your password was reset</O>,
		"en": () => <O>your password was reset</O>,
		"no": () => <O>your password was reset</O>,
		"sv": () => <O>your password was reset</O>,
	},

	"47666b867392": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>link slettet</O>,
		"de": () => <O>link deleted</O>,
		"en": () => <O>link deleted</O>,
		"no": () => <O>link deleted</O>,
		"sv": () => <O>link deleted</O>,
	},

	"eed629bea5c0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetning af blevet tildelt ny sagsbehandler</O>,
		"de": () => <O>Entry successfully re-assigned</O>,
		"en": () => <O>Entry successfully re-assigned</O>,
		"no": () => <O>Entry successfully re-assigned</O>,
		"sv": () => <O>Entry successfully re-assigned</O>,
	},

	"d5d9c636a53d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>timer</O>,
		"de": () => <O>hours</O>,
		"en": () => <O>hours</O>,
		"no": () => <O>hours</O>,
		"sv": () => <O>hours</O>,
	},

	"2608d398c9b8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>time</O>,
		"de": () => <O>hour</O>,
		"en": () => <O>hour</O>,
		"no": () => <O>hour</O>,
		"sv": () => <O>hour</O>,
	},

	"d8580fbb799e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>uge</O>,
		"de": () => <O>week</O>,
		"en": () => <O>week</O>,
		"no": () => <O>week</O>,
		"sv": () => <O>week</O>,
	},

	"0f5d9a7c0b7c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Note fra</O>,
		"de": () => <O>Note by</O>,
		"en": () => <O>Note by</O>,
		"no": () => <O>Note by</O>,
		"sv": () => <O>Note by</O>,
	},

	"27869f352930": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Besked fra</O>,
		"de": () => <O>Message by</O>,
		"en": () => <O>Message by</O>,
		"no": () => <O>Message by</O>,
		"sv": () => <O>Message by</O>,
	},

	"eaa4a35bf221": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>indlæs mere</O>,
		"de": () => <O>load more</O>,
		"en": () => <O>load more</O>,
		"no": () => <O>load more</O>,
		"sv": () => <O>load more</O>,
	},

	"bb34de47e3c8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Beskeder</O>,
		"de": () => <O>Messages</O>,
		"en": () => <O>Messages</O>,
		"no": () => <O>Messages</O>,
		"sv": () => <O>Messages</O>,
	},

	"b7cdc1a3e138": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Din nemme genvej til at overholde whistleblower-lovgivningen</O>,
		"de": () => <O>Your easy shortcut to complying with the whistleblower regulation</O>,
		"en": () => <O>Your easy shortcut to complying with the whistleblower regulation</O>,
		"no": () => <O>Your easy shortcut to complying with the whistleblower regulation</O>,
		"sv": () => <O>Your easy shortcut to complying with the whistleblower regulation</O>,
	},

	"ea8bcf9947f8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus er den billigste måde at sikre fuld overholdelse af whistleblowerloven. Pentus er sikker og intuitiv at bruge. Start din 14-dages uforpligtende og gratis prøveperiode i dag.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Pentus is the easiest way to ensure full compliance with the
                                        Whistleblower directive. Pentus is easy and secure. Start your
                                        14-day free trial period today.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Pentus is the easiest way to ensure full compliance with the
                                        Whistleblower directive. Pentus is easy and secure. Start your
                                        14-day free trial period today.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Pentus is the easiest way to ensure full compliance with the
                                        Whistleblower directive. Pentus is easy and secure. Start your
                                        14-day free trial period today.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Pentus is the easiest way to ensure full compliance with the
                                        Whistleblower directive. Pentus is easy and secure. Start your
                                        14-day free trial period today.
                                </O>
                        );
                },
	},

	"63452d4b6246": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kom igang nu</O>,
		"de": () => <O>Get started now</O>,
		"en": () => <O>Get started now</O>,
		"no": () => <O>Get started now</O>,
		"sv": () => <O>Get started now</O>,
	},

	"e485e63e8413": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Eller ring til os på </O>,
		"de": () => <O>Or call us at </O>,
		"en": () => <O>Or call us at </O>,
		"no": () => <O>Or call us at </O>,
		"sv": () => <O>Or call us at </O>,
	},

	"5a0c55f0806d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vælg den bedste løsning til dine behov</O>,
		"de": () => <O>Choose the best solution for your needs</O>,
		"en": () => <O>Choose the best solution for your needs</O>,
		"no": () => <O>Choose the best solution for your needs</O>,
		"sv": () => <O>Choose the best solution for your needs</O>,
	},

	"b73adf3845fa": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Det er hurtigt og nemt at få startet på din whistleblower-løsning. Vælg den
                                        optimale plan der passer til dit behov, ift. firmastørrelse og graden af service
                                        som du har brug for på daglig basis.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        It's fast and easy to get started with your whistleblower solution. Choose the
                                        optimal plan that suits your needs with regards to your size and the level of
                                        service you need on a day to day basis.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        It's fast and easy to get started with your whistleblower solution. Choose the
                                        optimal plan that suits your needs with regards to your size and the level of
                                        service you need on a day to day basis.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        It's fast and easy to get started with your whistleblower solution. Choose the
                                        optimal plan that suits your needs with regards to your size and the level of
                                        service you need on a day to day basis.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        It's fast and easy to get started with your whistleblower solution. Choose the
                                        optimal plan that suits your needs with regards to your size and the level of
                                        service you need on a day to day basis.
                                </O>
                        );
                },
	},

	"7de12ed60bf8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Der er ingen links oprettet til indsendelse af indberetning</O>,
		"de": () => <O>There is no links created for sumitting entries</O>,
		"en": () => <O>There is no links created for sumitting entries</O>,
		"no": () => <O>There is no links created for sumitting entries</O>,
		"sv": () => <O>There is no links created for sumitting entries</O>,
	},

	"b5f1f8f629ca": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Du har ingen tildelte sager endnu</O>,
		"de": () => <O>You have no assigned cases yet</O>,
		"en": () => <O>You have no assigned cases yet</O>,
		"no": () => <O>You have no assigned cases yet</O>,
		"sv": () => <O>You have no assigned cases yet</O>,
	},

	"22502c6320d9": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Test og del nedenstående link med dine medarbejdere</O>,
		"de": () => <O>Test and share the link below to your employees</O>,
		"en": () => <O>Test and share the link below to your employees</O>,
		"no": () => <O>Test and share the link below to your employees</O>,
		"sv": () => <O>Test and share the link below to your employees</O>,
	},

	"7d1de27d2f1e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>for at indsende sager</O>,
		"de": () => <O>in order to submit cases</O>,
		"en": () => <O>in order to submit cases</O>,
		"no": () => <O>in order to submit cases</O>,
		"sv": () => <O>in order to submit cases</O>,
	},

	"ff299e4199bb": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Sørg for, at dit link er aktivt</O>,
		"de": () => <O>Make sure your link is active</O>,
		"en": () => <O>Make sure your link is active</O>,
		"no": () => <O>Make sure your link is active</O>,
		"sv": () => <O>Make sure your link is active</O>,
	},

	"32e4010b9ecb": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>så dine kolleger kan foretage en indberetning</O>,
		"de": () => <O>so your colleagues are able to file a case</O>,
		"en": () => <O>so your colleagues are able to file a case</O>,
		"no": () => <O>so your colleagues are able to file a case</O>,
		"sv": () => <O>so your colleagues are able to file a case</O>,
	},

	"37ac8e762314": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Lav nyt link</O>,
		"de": () => <O>Generate New Link</O>,
		"en": () => <O>Generate New Link</O>,
		"no": () => <O>Generate New Link</O>,
		"sv": () => <O>Generate New Link</O>,
	},

	"c5ac080035ba": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Redigér dine detaljer</O>,
		"de": () => <O>Edit your details</O>,
		"en": () => <O>Edit your details</O>,
		"no": () => <O>Edit your details</O>,
		"sv": () => <O>Edit your details</O>,
	},

	"c12983a7e618": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Brugerinformation</O>,
		"de": () => <O>User information</O>,
		"en": () => <O>User information</O>,
		"no": () => <O>User information</O>,
		"sv": () => <O>User information</O>,
	},

	"9f6d74f3abc0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Her kan du rette i dine brugerinformationer </O>,
		"de": () => <O>Here there supposed to be some meaningful text</O>,
		"en": () => <O>Here there supposed to be some meaningful text</O>,
		"no": () => <O>Here there supposed to be some meaningful text</O>,
		"sv": () => <O>Here there supposed to be some meaningful text</O>,
	},

	"95eecb0c6435": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>og ændre dit kodeord </O>,
		"de": () => <O>about user stuff, the planet of xpiwtr and blueberry pie...</O>,
		"en": () => <O>and change your password</O>,
		"no": () => <O>about user stuff, the planet of xpiwtr and blueberry pie...</O>,
		"sv": () => <O>about user stuff, the planet of xpiwtr and blueberry pie...</O>,
	},

	"179d674347fd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>brugernavn</O>,
		"de": () => <O>username</O>,
		"en": () => <O>username</O>,
		"no": () => <O>username</O>,
		"sv": () => <O>username</O>,
	},

	"a12b259bf1cb": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>OPDATER</O>,
		"de": () => <O>SUBMIT</O>,
		"en": () => <O>SUBMIT</O>,
		"no": () => <O>SUBMIT</O>,
		"sv": () => <O>SUBMIT</O>,
	},

	"d2d0e6f5eb7a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Log ud</O>,
		"de": () => <O>Logout</O>,
		"en": () => <O>Logout</O>,
		"no": () => <O>Logout</O>,
		"sv": () => <O>Logout</O>,
	},

	"4c60481eb6bf": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>FAQ</O>,
		"de": () => <O>FAQ</O>,
		"en": () => <O>FAQ</O>,
		"no": () => <O>FAQ</O>,
		"sv": () => <O>FAQ</O>,
	},

	"8943eff1a78e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kontakt os</O>,
		"de": () => <O>Contact us</O>,
		"en": () => <O>Contact us</O>,
		"no": () => <O>Contact us</O>,
		"sv": () => <O>Contact us</O>,
	},

	"770b14d956c6": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Book demo</O>,
		"de": () => <O>Book demo</O>,
		"en": () => <O>Book demo</O>,
		"no": () => <O>Book demo</O>,
		"sv": () => <O>Book demo</O>,
	},

	"191da78e46b4": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Om</O>,
		"de": () => <O>About</O>,
		"en": () => <O>About</O>,
		"no": () => <O>About</O>,
		"sv": () => <O>About</O>,
	},

	"7c5162478a35": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Vi vil altid gerne høre fra dig, samt besvare ethvert spørgsmål du måtte have.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        We would always like to hear from you, or answer any
                                        questions you might have.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        We would always like to hear from you, or answer any
                                        questions you might have.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        We would always like to hear from you, or answer any
                                        questions you might have.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        We would always like to hear from you, or answer any
                                        questions you might have.
                                </O>
                        );
                },
	},

	"5d509fbb1624": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Prøv det gratis</O>,
		"de": () => <O>Free trial</O>,
		"en": () => <O>Free trial</O>,
		"no": () => <O>Free trial</O>,
		"sv": () => <O>Free trial</O>,
	},

	"4a8112c5cdf8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Anonym tilstand</O>,
		"de": () => <O>Anonymous mode</O>,
		"en": () => <O>Anonymous mode</O>,
		"no": () => <O>Anonymous mode</O>,
		"sv": () => <O>Anonymous mode</O>,
	},

	"d40cd1ae0c52": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Fortroligt</O>,
		"de": () => <O>Confidential mode</O>,
		"en": () => <O>Confidential mode</O>,
		"no": () => <O>Confidential mode</O>,
		"sv": () => <O>Confidential mode</O>,
	},

	"bd5ae230249f": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Forsiden</O>,
		"de": () => <O>Front page</O>,
		"en": () => <O>Front page</O>,
		"no": () => <O>Front page</O>,
		"sv": () => <O>Front page</O>,
	},

	"d2b822582b73": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Priser</O>,
		"de": () => <O>Pricing</O>,
		"en": () => <O>Pricing</O>,
		"no": () => <O>Pricing</O>,
		"sv": () => <O>Pricing</O>,
	},

	"5fc57986ac86": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>INDBERETNINGER</O>,
		"de": () => <O>ENTRIES</O>,
		"en": () => <O>ENTRIES</O>,
		"no": () => <O>ENTRIES</O>,
		"sv": () => <O>ENTRIES</O>,
	},

	"663f7f13d8e7": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetninger</O>,
		"de": () => <O>Entries</O>,
		"en": () => <O>Entries</O>,
		"no": () => <O>Entries</O>,
		"sv": () => <O>Entries</O>,
	},

	"8872ad23b40d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Alle spørgsmål</O>,
		"de": () => <O>All questions</O>,
		"en": () => <O>All questions</O>,
		"no": () => <O>All questions</O>,
		"sv": () => <O>All questions</O>,
	},

	"9b2d6d0d1ef8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvad er en whistleblower?</O>,
		"de": () => <O>What is a whistleblower?</O>,
		"en": () => <O>What is a whistleblower?</O>,
		"no": () => <O>What is a whistleblower?</O>,
		"sv": () => <O>What is a whistleblower?</O>,
	},

	"9d43357a0d33": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        En whistleblower er en person, der har en tilknytning til en virksomhed og indberetter oplysninger
                                        om forhold på arbejdspladsen, såsom krænkende adfærd eller ulovligheder som f.eks. skattesvindel –
                                        men det kan også være mange andre typer at forseelser.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        A whistleblower is a person who has a connection to a company and reports information about conditions in the
                                        workplace, such as abusive behavior or illegalities such as tax fraud – but it can also be many other types of
                                        offences.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        A whistleblower is a person who has a connection to a company and reports information about conditions in the
                                        workplace, such as abusive behavior or illegalities such as tax fraud – but it can also be many other types of
                                        offences.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        A whistleblower is a person who has a connection to a company and reports information about conditions in the
                                        workplace, such as abusive behavior or illegalities such as tax fraud – but it can also be many other types of
                                        offences.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        A whistleblower is a person who has a connection to a company and reports information about conditions in the
                                        workplace, such as abusive behavior or illegalities such as tax fraud – but it can also be many other types of
                                        offences.
                                </O>
                        );
                },
	},

	"4d11c15b994e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvornår får jeg svar på min indberetning?</O>,
		"de": () => <O>When will my case be answered?</O>,
		"en": () => <O>When will my case be answered?</O>,
		"no": () => <O>When will my case be answered?</O>,
		"sv": () => <O>When will my case be answered?</O>,
	},

	"b14665cce5c8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Når vi modtager en indberetning fra dig, får du en bekræftelse på modtagelse, senest 7 dage efter
                                        den er sendt. Fra bekræftelsesdatoen vil du modtage feedback om behandlingen af din sag, inden 3
                                        .
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        When we receive a report from you, you will receive a confirmation of receipt, no later than 7 days after it has
                                        been sent.  From the confirmation date, you will receive feedback on the processing of your case within 3 months.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        When we receive a report from you, you will receive a confirmation of receipt, no later than 7 days after it has
                                        been sent.  From the confirmation date, you will receive feedback on the processing of your case within 3 months.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        When we receive a report from you, you will receive a confirmation of receipt, no later than 7 days after it has
                                        been sent.  From the confirmation date, you will receive feedback on the processing of your case within 3 months.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        When we receive a report from you, you will receive a confirmation of receipt, no later than 7 days after it has
                                        been sent.  From the confirmation date, you will receive feedback on the processing of your case within 3 months.
                                </O>
                        );
                },
	},

	"785ce300a995": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvad er en whistleblowerenhed?</O>,
		"de": () => <O>What is a whistleblower unit?</O>,
		"en": () => <O>What is a whistleblower unit?</O>,
		"no": () => <O>What is a whistleblower unit?</O>,
		"sv": () => <O>What is a whistleblower unit?</O>,
	},

	"ba135d6b58e4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        En whistleblowers enhed er den enhed, der modtager indberetninger fra whistleblowers. En intern
                                        enhed fungerer inden for virksomheden, mens en ekstern enhed fungerer uden for virksomheden. Enheden
                                        skal enten behandle indberetningen selv eller, hvis det er nødvendigt, videresende den til den
                                        juridiske afdeling, ledelsen på den relevante arbejdsplads, eller til de kompetente myndigheder.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        A whistleblower's unit is the unit that receives reports from whistleblowers. An internal entity operates within the
                                        company, while an external entity operates outside the company. The unit must either process the report itself or,
                                        if necessary, forward it to the legal department, management at the relevant workplace, or to the competent
                                        authorities
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        A whistleblower's unit is the unit that receives reports from whistleblowers. An internal entity operates within the
                                        company, while an external entity operates outside the company. The unit must either process the report itself or,
                                        if necessary, forward it to the legal department, management at the relevant workplace, or to the competent
                                        authorities
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        A whistleblower's unit is the unit that receives reports from whistleblowers. An internal entity operates within the
                                        company, while an external entity operates outside the company. The unit must either process the report itself or,
                                        if necessary, forward it to the legal department, management at the relevant workplace, or to the competent
                                        authorities
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        A whistleblower's unit is the unit that receives reports from whistleblowers. An internal entity operates within the
                                        company, while an external entity operates outside the company. The unit must either process the report itself or,
                                        if necessary, forward it to the legal department, management at the relevant workplace, or to the competent
                                        authorities
                                </O>
                        );
                },
	},

	"3b85304da6b8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvilke forhold kan man indberette?</O>,
		"de": () => <O>What can be reported?</O>,
		"en": () => <O>What can be reported?</O>,
		"no": () => <O>What can be reported?</O>,
		"sv": () => <O>What can be reported?</O>,
	},

	"a292ac409250": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Whistleblowerordningen bør anvendes, hvis du får kendskab eller mistanke om alvorlige overtrædelser
                                        af lovgivningen i forbindelse med aktiviteter og drift i selskabet, såsom misbrug af økonomiske
                                        midler, hvidvask, bestikkelse, bedrageri, tyveri og underslæb, uregelmæssigheder ved regnskabsføring
                                        og revision, gentagne overtrædelser af lovgivningen (f.eks. databeskyttelseslovgivningen), grove
                                        personrelaterede konflikter i selskabet, seksuelle krænkelser og vold, og grov chikane på grund af
                                        race, politisk eller religiøst tilhørsforhold.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        The whistleblower scheme should be used if you become aware of or suspect serious violations of the law in
                                        connection with activities and operations in the company, such as misuse of financial funds, money laundering,
                                        bribery, fraud, theft and embezzlement, irregularities in accounting and auditing, repeated violations of the law
                                        (e.g. data protection legislation), gross personal conflicts in the company, sexual violations and violence, and
                                        gross harassment due to race, political or religious affiliation.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        The whistleblower scheme should be used if you become aware of or suspect serious violations of the law in
                                        connection with activities and operations in the company, such as misuse of financial funds, money laundering,
                                        bribery, fraud, theft and embezzlement, irregularities in accounting and auditing, repeated violations of the law
                                        (e.g. data protection legislation), gross personal conflicts in the company, sexual violations and violence, and
                                        gross harassment due to race, political or religious affiliation.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        The whistleblower scheme should be used if you become aware of or suspect serious violations of the law in
                                        connection with activities and operations in the company, such as misuse of financial funds, money laundering,
                                        bribery, fraud, theft and embezzlement, irregularities in accounting and auditing, repeated violations of the law
                                        (e.g. data protection legislation), gross personal conflicts in the company, sexual violations and violence, and
                                        gross harassment due to race, political or religious affiliation.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        The whistleblower scheme should be used if you become aware of or suspect serious violations of the law in
                                        connection with activities and operations in the company, such as misuse of financial funds, money laundering,
                                        bribery, fraud, theft and embezzlement, irregularities in accounting and auditing, repeated violations of the law
                                        (e.g. data protection legislation), gross personal conflicts in the company, sexual violations and violence, and
                                        gross harassment due to race, political or religious affiliation.
                                </O>
                        );
                },
	},

	"5574f5e962a2": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvem må indberette?</O>,
		"de": () => <O>Who can report?</O>,
		"en": () => <O>Who can report?</O>,
		"no": () => <O>Who can report?</O>,
		"sv": () => <O>Who can report?</O>,
	},

	"bc1dbb17c82b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Som udgangspunkt har alle medarbejdere, herunder fuldtids- og deltidsansatte, tidsbegrænsede
                                        ansættelser (projektansættelser), praktikanter (både lønnede og ulønnede) og vikarer, mulighed for
                                        at foretage indberetninger. Direktionen af virksomheden kan også vælge at inkludere leverandører,
                                        kommende ansatte, frivillige og tidligere ansatte i whistleblowerordningen.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        As a starting point, all employees, including full-time and part-time employees, temporary employment (project
                                        employment), interns (both paid and unpaid) and temps, have the opportunity to make reports. The management of the
                                        company can also choose to include suppliers, future employees, volunteers and former employees in the whistleblower
                                        scheme.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        As a starting point, all employees, including full-time and part-time employees, temporary employment (project
                                        employment), interns (both paid and unpaid) and temps, have the opportunity to make reports. The management of the
                                        company can also choose to include suppliers, future employees, volunteers and former employees in the whistleblower
                                        scheme.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        As a starting point, all employees, including full-time and part-time employees, temporary employment (project
                                        employment), interns (both paid and unpaid) and temps, have the opportunity to make reports. The management of the
                                        company can also choose to include suppliers, future employees, volunteers and former employees in the whistleblower
                                        scheme.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        As a starting point, all employees, including full-time and part-time employees, temporary employment (project
                                        employment), interns (both paid and unpaid) and temps, have the opportunity to make reports. The management of the
                                        company can also choose to include suppliers, future employees, volunteers and former employees in the whistleblower
                                        scheme.
                                </O>
                        );
                },
	},

	"9f039c9c9ff7": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvornår er det påkrævet i loven at have en whistleblowerenhed?</O>,
		"de": () => <O>When is the whistleblower unit required by law?</O>,
		"en": () => <O>When is the whistleblower unit required by law?</O>,
		"no": () => <O>When is the whistleblower unit required by law?</O>,
		"sv": () => <O>When is the whistleblower unit required by law?</O>,
	},

	"90e0cbfa2fd9": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Fra 17. december 2021 skulle store virksomheder (250 medarbejdere eller derover) have en
                                        whistleblowerordning. Mellemstore virksomheder (50-249 medarbejdere) skal have en
                                        whistleblowerordning pr. 17. december 2023. Der er ikke påkrav om en whistleblowerordning for mindre
                                        virksomheder (med 49 medarbejdere eller derunder), men det kan være en god ide at have en sådan
                                        ordning.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Per 17 December 2021, large companies (250 employees or more) had to have a whistleblower scheme. Medium-sized
                                        companies (50-249 employees) must have a whistleblower scheme per 17 December 2023. There is no requirement for a
                                        whistleblower scheme for smaller companies (with 49 employees or less), but it may be a good idea to have such a
                                        scheme.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Per 17 December 2021, large companies (250 employees or more) had to have a whistleblower scheme. Medium-sized
                                        companies (50-249 employees) must have a whistleblower scheme per 17 December 2023. There is no requirement for a
                                        whistleblower scheme for smaller companies (with 49 employees or less), but it may be a good idea to have such a
                                        scheme.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Per 17 December 2021, large companies (250 employees or more) had to have a whistleblower scheme. Medium-sized
                                        companies (50-249 employees) must have a whistleblower scheme per 17 December 2023. There is no requirement for a
                                        whistleblower scheme for smaller companies (with 49 employees or less), but it may be a good idea to have such a
                                        scheme.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Per 17 December 2021, large companies (250 employees or more) had to have a whistleblower scheme. Medium-sized
                                        companies (50-249 employees) must have a whistleblower scheme per 17 December 2023. There is no requirement for a
                                        whistleblower scheme for smaller companies (with 49 employees or less), but it may be a good idea to have such a
                                        scheme.
                                </O>
                        );
                },
	},

	"c37e9c273e2a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvad er forskellen mellem intern og ekstern whistleblowerenhed?</O>,
		"de": () => <O>What is the difference between internal and external whistleblower unit?</O>,
		"en": () => <O>What is the difference between internal and external whistleblower unit?</O>,
		"no": () => <O>What is the difference between internal and external whistleblower unit?</O>,
		"sv": () => <O>What is the difference between internal and external whistleblower unit?</O>,
	},

	"51fc365308ee": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Ved en ekstern whistleblowerenhed, ved indberetningen ske til en anden virksomhed og det samme med
                                        den juridiske behandling. Whistlebloweren kan hermed med en højere grad af fortrolighed eller
                                        anonymitet indsende sin indberetning. En ekstern whistleblowerenhed er også under påkrav til at
                                        kunne modtage både skriftlige og mundtlige indberetninger, dette er ikke et krav for interne
                                        enheder.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        In the case of an external whistleblower unit, the report should be made to another company and the same with the
                                        legal treatment. The whistleblower can hereby submit his report with a higher degree of confidentiality or
                                        anonymity.  An external whistleblower unit is also required to be able to receive both written and oral reports,
                                        this is not a requirement for internal units.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        In the case of an external whistleblower unit, the report should be made to another company and the same with the
                                        legal treatment. The whistleblower can hereby submit his report with a higher degree of confidentiality or
                                        anonymity.  An external whistleblower unit is also required to be able to receive both written and oral reports,
                                        this is not a requirement for internal units.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        In the case of an external whistleblower unit, the report should be made to another company and the same with the
                                        legal treatment. The whistleblower can hereby submit his report with a higher degree of confidentiality or
                                        anonymity.  An external whistleblower unit is also required to be able to receive both written and oral reports,
                                        this is not a requirement for internal units.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        In the case of an external whistleblower unit, the report should be made to another company and the same with the
                                        legal treatment. The whistleblower can hereby submit his report with a higher degree of confidentiality or
                                        anonymity.  An external whistleblower unit is also required to be able to receive both written and oral reports,
                                        this is not a requirement for internal units.
                                </O>
                        );
                },
	},

	"f27b626ff805": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Du har spørgsmålene</O>,
		"de": () => <O>You have the questions</O>,
		"en": () => <O>You have the questions</O>,
		"no": () => <O>You have the questions</O>,
		"sv": () => <O>You have the questions</O>,
	},

	"17d5e5f02434": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vi har svarene</O>,
		"de": () => <O>We have the answers</O>,
		"en": () => <O>We have the answers</O>,
		"no": () => <O>We have the answers</O>,
		"sv": () => <O>We have the answers</O>,
	},

	"9b21aff66b84": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Populære spørgsmål</O>,
		"de": () => <O>Top questions</O>,
		"en": () => <O>Top questions</O>,
		"no": () => <O>Top questions</O>,
		"sv": () => <O>Top questions</O>,
	},

	"251f36692578": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Prøv Pentus nu</O>,
		"de": () => <O>Try Pentus right now</O>,
		"en": () => <O>Try Pentus right now</O>,
		"no": () => <O>Try Pentus right now</O>,
		"sv": () => <O>Try Pentus right now</O>,
	},

	"5b4dcfb1358e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Intet kreditkort nødvendigt</O>,
		"de": () => <O>No credit card required</O>,
		"en": () => <O>No credit card required</O>,
		"no": () => <O>No credit card required</O>,
		"sv": () => <O>No credit card required</O>,
	},

	"a74fedec6701": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Sikkerhed hver dag for dig og dine ansatte med Pentus</O>,
		"de": () => <O>Every day safety for you and your employees with Pentus</O>,
		"en": () => <O>Every day safety for you and your employees with Pentus</O>,
		"no": () => <O>Every day safety for you and your employees with Pentus</O>,
		"sv": () => <O>Every day safety for you and your employees with Pentus</O>,
	},

	"65b292ea8eb8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>En whistleblowerordning fremmer åbenhed og integritet på arbejdspladsen ved at give medarbejderne et sted, hvor de kan rapportere uretmæssig adfærd.</O>,
		"de": () => <O>A whistleblower scheme promotes openness and integrity in the workplace by providing employees with a place to report wrongful behavior.</O>,
		"en": () => <O>A whistleblower scheme promotes openness and integrity in the workplace by providing employees with a place to report wrongful behavior.</O>,
		"no": () => <O>A whistleblower scheme promotes openness and integrity in the workplace by providing employees with a place to report wrongful behavior.</O>,
		"sv": () => <O>A whistleblower scheme promotes openness and integrity in the workplace by providing employees with a place to report wrongful behavior.</O>,
	},

	"4a1e25e67c56": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Det er obligatorisk for alle virksomheder med mere end 249 ansatte, og det vil også være obligatorisk for virksomheder med over 49 ansatte fra den 17. december 2023.</O>,
		"de": () => <O>It is mandatory for all companies with more than 249 employees and will also be mandatory for companies with over 49 employees from December 17, 2023.</O>,
		"en": () => <O>It is mandatory for all companies with more than 249 employees and will also be mandatory for companies with over 49 employees from December 17, 2023.</O>,
		"no": () => <O>It is mandatory for all companies with more than 249 employees and will also be mandatory for companies with over 49 employees from December 17, 2023.</O>,
		"sv": () => <O>It is mandatory for all companies with more than 249 employees and will also be mandatory for companies with over 49 employees from December 17, 2023.</O>,
	},

	"64f9e3e27396": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Pentus er udviklet af danske softwareudviklere i Odense. Alle dine data forbliver dermed i EU, og vi klarer alt papirarbejdet, så du kan starte med det samme.</O>,
		"de": () => <O>Pentus is a system developed by Danish software programmers in Odense. All your data is within the EU and we take care of all the paperwork so you can get started right away.</O>,
		"en": () => <O>Pentus is a system developed by Danish software programmers in Odense. All your data is within the EU and we take care of all the paperwork so you can get started right away.</O>,
		"no": () => <O>Pentus is a system developed by Danish software programmers in Odense. All your data is within the EU and we take care of all the paperwork so you can get started right away.</O>,
		"sv": () => <O>Pentus is a system developed by Danish software programmers in Odense. All your data is within the EU and we take care of all the paperwork so you can get started right away.</O>,
	},

	"9f2adaec3171": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Whistleblower solution by Pentus ApS</O>,
		"de": () => <O>Whistleblower solution by Pentus ApS</O>,
		"en": () => <O>Whistleblower solution by Pentus ApS</O>,
		"no": () => <O>Whistleblower solution by Pentus ApS</O>,
		"sv": () => <O>Whistleblower solution by Pentus ApS</O>,
	},

	"13c8198c10ee": {
		"da": () => <O>Velkommen til Pentus</O>,
		"de": () => <O>Willkommen bei Pentus</O>,
		"en": () => <O>Welcome to Pentus</O>,
		"no": () => <O>Velkommen til Pentus</O>,
		"sv": () => <O>Välkommen till Pentus</O>,
	},

	"690806e5fb4e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Log ind</O>,
		"de": () => <O>Login</O>,
		"en": () => <O>Login</O>,
		"no": () => <O>Login</O>,
		"sv": () => <O>Login</O>,
	},

	"a95c63e72cf1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Dashboard</O>,
		"de": () => <O>Dashboard</O>,
		"en": () => <O>Dashboard</O>,
		"no": () => <O>Dashboard</O>,
		"sv": () => <O>Dashboard</O>,
	},

	"99e675f6f662": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Status</O>,
		"de": () => <O>Status</O>,
		"en": () => <O>Status</O>,
		"no": () => <O>Status</O>,
		"sv": () => <O>Status</O>,
	},

	"3df7113a98ee": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kategori</O>,
		"de": () => <O>Category</O>,
		"en": () => <O>Category</O>,
		"no": () => <O>Category</O>,
		"sv": () => <O>Category</O>,
	},

	"07c8dfbd3724": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Behandler af indberetning</O>,
		"de": () => <O>Assigned</O>,
		"en": () => <O>Assigned</O>,
		"no": () => <O>Assigned</O>,
		"sv": () => <O>Assigned</O>,
	},

	"53c133ffd6e0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Set visibility as recipients</O>,
		"de": () => <O>Set visibility as recipients</O>,
		"en": () => <O>Set visibility as recipients</O>,
		"no": () => <O>Set visibility as recipients</O>,
		"sv": () => <O>Set visibility as recipients</O>,
	},

	"0740a90fd181": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Whistlebloweren skal kunne vælge denne bruger som behandler af sin indberetning </O>,
		"de": () => <O>Show as assignee at case creation</O>,
		"en": () => <O>Show as assignee at case creation</O>,
		"no": () => <O>Show as assignee at case creation</O>,
		"sv": () => <O>Show as assignee at case creation</O>,
	},

	"d1fb3034fd9c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for the
					case, when a case reporter creates the case.
				</O>
			);
		},
		"de": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for the
					case, when a case reporter creates the case.
				</O>
			);
		},
		"en": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for the
					case, when a case reporter creates the case.
				</O>
			);
		},
		"no": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for the
					case, when a case reporter creates the case.
				</O>
			);
		},
		"sv": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for the
					case, when a case reporter creates the case.
				</O>
			);
		},
	},

	"df4cf79baddd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vis denne bruger på liste over mulige modtagere, hvis eksisterende indberetning skal tildeles ny sagsbehandler</O>,
		"de": () => <O>Show as assignee at case assignment</O>,
		"en": () => <O>Show as assignee at case assignment</O>,
		"no": () => <O>Show as assignee at case assignment</O>,
		"sv": () => <O>Show as assignee at case assignment</O>,
	},

	"38b926296b2b": {
		"da": () => {
			return (
				<O>
                                        En sagsbehandler skal kunne videresende indberetningen til denne bruger
				</O>
			);
		},
		"de": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for case
					workers when re-assigning a case.
				</O>
			);
		},
		"en": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for case
					workers when re-assigning a case.
				</O>
			);
		},
		"no": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for case
					workers when re-assigning a case.
				</O>
			);
		},
		"sv": () => {
			return (
				<O>
					If active, this user will a possibility as a recipient for case
					workers when re-assigning a case.
				</O>
			);
		},
	},

	"e1eb91616a5b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>E-mail</O>,
		"de": () => <O>Email</O>,
		"en": () => <O>Email</O>,
		"no": () => <O>Email</O>,
		"sv": () => <O>Email</O>,
	},

	"ef93ceabb3cf": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>indsæt email</O>,
		"de": () => <O>insert email</O>,
		"en": () => <O>insert email</O>,
		"no": () => <O>insert email</O>,
		"sv": () => <O>insert email</O>,
	},

	"7ea77464b0ee": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Del indberetning</O>,
		"de": () => <O>Share Entry</O>,
		"en": () => <O>Share Entry</O>,
		"no": () => <O>Share Entry</O>,
		"sv": () => <O>Share Entry</O>,
	},

	"f2b8912ebb92": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Er du sikker på, at du vil give adgang til indberetningen?</O>,
		"de": () => <O>Are you sure you want to give access to the entry?</O>,
		"en": () => <O>Are you sure you want to give access to the entry?</O>,
		"no": () => <O>Are you sure you want to give access to the entry?</O>,
		"sv": () => <O>Are you sure you want to give access to the entry?</O>,
	},

	"66df4124fd38": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indsæt kommentar til den nye sagsbehandler af indberetningen</O>,
		"de": () => <O>comment</O>,
		"en": () => <O>comment</O>,
		"no": () => <O>comment</O>,
		"sv": () => <O>comment</O>,
	},

	"7540c8679e76": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Giv dit link et alias</O>,
		"de": () => <O>Give your link an alias</O>,
		"en": () => <O>Give your link an alias</O>,
		"no": () => <O>Give your link an alias</O>,
		"sv": () => <O>Give your link an alias</O>,
	},

	"df115d1032a8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        En brugervenlig platform til at overholde whistleblower-lovgivningen.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        A user-friendly application to meet the needs for whistleblower regulation
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        A user-friendly application to meet the needs for whistleblower regulation
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        A user-friendly application to meet the needs for whistleblower regulation
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        A user-friendly application to meet the needs for whistleblower regulation
                                </O>
                        );
                },
	},

	"1ab00f090c12": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus whistleblower-software er en innovativ og sikker platform designet til at styrke personer til
                                        at rapportere uetisk adfærd, misforhold og overtrædelser af overholdelse inden for organisationer.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Pentus Whistleblower Software is an innovative and secure platform designed to
                                        empower individuals to report unethical behavior, misconduct, and compliance
                                        violations within organizations.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Pentus Whistleblower Software is an innovative and secure platform designed to
                                        empower individuals to report unethical behavior, misconduct, and compliance
                                        violations within organizations.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Pentus Whistleblower Software is an innovative and secure platform designed to
                                        empower individuals to report unethical behavior, misconduct, and compliance
                                        violations within organizations.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Pentus Whistleblower Software is an innovative and secure platform designed to
                                        empower individuals to report unethical behavior, misconduct, and compliance
                                        violations within organizations.
                                </O>
                        );
                },
	},

	"6188ca11ba23": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Pentus er en brugervenlig, webbaseret applikation designet til at lette anonym rapportering af
                                        bekymringer og hændelser inden for organisationer. Vores platform prioriterer fortrolighed og
                                        sikkerhed for at sikre, at whistleblowere kan rapportere hændelser uden frygt for gengældelse.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Our Whistleblower Software is a user-friendly, web-based application designed to
                                        facilitate anonymous reporting of concerns and incidents within organizations. Our
                                        platform prioritizes confidentiality and security to ensure that whistleblowers can
                                        report incidents without fear of retaliation.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Our Whistleblower Software is a user-friendly, web-based application designed to
                                        facilitate anonymous reporting of concerns and incidents within organizations. Our
                                        platform prioritizes confidentiality and security to ensure that whistleblowers can
                                        report incidents without fear of retaliation.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Our Whistleblower Software is a user-friendly, web-based application designed to
                                        facilitate anonymous reporting of concerns and incidents within organizations. Our
                                        platform prioritizes confidentiality and security to ensure that whistleblowers can
                                        report incidents without fear of retaliation.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Our Whistleblower Software is a user-friendly, web-based application designed to
                                        facilitate anonymous reporting of concerns and incidents within organizations. Our
                                        platform prioritizes confidentiality and security to ensure that whistleblowers can
                                        report incidents without fear of retaliation.
                                </O>
                        );
                },
	},

	"2598f809c15f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Nøglefunktioner</O>,
		"de": () => <O>Key features</O>,
		"en": () => <O>Key features</O>,
		"no": () => <O>Key features</O>,
		"sv": () => <O>Key features</O>,
	},

	"52e59ae9be3b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Fortrolighed og anonymitet: Vores software giver en sikker og krypteret kommunikationskanal, der
                                        beskytter whistleblowerens identitet. Vi forstår vigtigheden af anonymitet, og vores platform er
                                        bygget med avancerede sikkerhedsforanstaltninger for at opretholde det højeste niveau af
                                        fortrolighed.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Confidentiality and Anonymity: Our software provides a secure and encrypted
                                        communication channel that safeguards the whistleblower's identity. We
                                        understand the importance of anonymity, and our platform is built with
                                        advanced security measures to maintain the highest level of confidentiality.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Confidentiality and Anonymity: Our software provides a secure and encrypted
                                        communication channel that safeguards the whistleblower's identity. We
                                        understand the importance of anonymity, and our platform is built with
                                        advanced security measures to maintain the highest level of confidentiality.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Confidentiality and Anonymity: Our software provides a secure and encrypted
                                        communication channel that safeguards the whistleblower's identity. We
                                        understand the importance of anonymity, and our platform is built with
                                        advanced security measures to maintain the highest level of confidentiality.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Confidentiality and Anonymity: Our software provides a secure and encrypted
                                        communication channel that safeguards the whistleblower's identity. We
                                        understand the importance of anonymity, and our platform is built with
                                        advanced security measures to maintain the highest level of confidentiality.
                                </O>
                        );
                },
	},

	"f862473c3bbe": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Tilpasset rapportering: Vores platform giver organisationer mulighed for at bruge
                                        rapporteringskategorier og spørgsmål for at imødekomme deres unikke behov og sikre, at relevant
                                        information indfanges effektivt.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Customizable Reporting: Our platform allows organizations to use categories
                                        and questions that suit their unique needs, ensuring that the relevant
                                        information is captured effectively.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Customizable Reporting: Our platform allows organizations to use categories
                                        and questions that suit their unique needs, ensuring that the relevant
                                        information is captured effectively.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Customizable Reporting: Our platform allows organizations to use categories
                                        and questions that suit their unique needs, ensuring that the relevant
                                        information is captured effectively.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Customizable Reporting: Our platform allows organizations to use categories
                                        and questions that suit their unique needs, ensuring that the relevant
                                        information is captured effectively.
                                </O>
                        );
                },
	},

	"2a11d42e3ea5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Support for flere sprog: Pentus understøtter flere sprog, hvilket gør det
                                        muligt for organisationer at tilbyde en rapporteringsplatform, der er tilgængelig for en
                                        forskelligartet arbejdsstyrke.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Multi-language Support: Pentus Whistleblower Software supports Danish and
                                        English, enabling organizations to provide a reporting platform that is
                                        accessible to a diverse workforce.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Multi-language Support: Pentus Whistleblower Software supports Danish and
                                        English, enabling organizations to provide a reporting platform that is
                                        accessible to a diverse workforce.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Multi-language Support: Pentus Whistleblower Software supports Danish and
                                        English, enabling organizations to provide a reporting platform that is
                                        accessible to a diverse workforce.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Multi-language Support: Pentus Whistleblower Software supports Danish and
                                        English, enabling organizations to provide a reporting platform that is
                                        accessible to a diverse workforce.
                                </O>
                        );
                },
	},

	"6ef3e48d4b67": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Realtidsnotifikationer: Vores software leverer realtidsnotifikationer til sagsbehandlere, hvilket
                                        giver organisationer mulighed for hurtigt at adressere rapporterede hændelser og træffe passende
                                        foranstaltninger.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Real-time Notifications: Our software delivers real-time notifications to
                                        designated case managers, allowing organizations to promptly address
                                        reported incidents and take appropriate action.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Real-time Notifications: Our software delivers real-time notifications to
                                        designated case managers, allowing organizations to promptly address
                                        reported incidents and take appropriate action.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Real-time Notifications: Our software delivers real-time notifications to
                                        designated case managers, allowing organizations to promptly address
                                        reported incidents and take appropriate action.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Real-time Notifications: Our software delivers real-time notifications to
                                        designated case managers, allowing organizations to promptly address
                                        reported incidents and take appropriate action.
                                </O>
                        );
                },
	},

	"13e8e418ecd7": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Intuitiv sagshåndtering: Vores platform indeholder et nemt at bruge sagshåndteringssystem, der gør
                                        det muligt for organisationer at håndtere og spore fremgangen i rapporterede hændelser effektivt.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Intuitive Case Management: Our platform features an easy-to-use case
                                        management system that enables organizations to efficiently manage and track
                                        the progress of reported incidents.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Intuitive Case Management: Our platform features an easy-to-use case
                                        management system that enables organizations to efficiently manage and track
                                        the progress of reported incidents.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Intuitive Case Management: Our platform features an easy-to-use case
                                        management system that enables organizations to efficiently manage and track
                                        the progress of reported incidents.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Intuitive Case Management: Our platform features an easy-to-use case
                                        management system that enables organizations to efficiently manage and track
                                        the progress of reported incidents.
                                </O>
                        );
                },
	},

	"49a068ff7cec": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tak for din besked, vi vender tilbage til dig så hurtigt som muligt.</O>,
		"de": () => <O>Thank you for your message. We will get back to you as soon as possible.</O>,
		"en": () => <O>Thank you for your message. We will get back to you as soon as possible.</O>,
		"no": () => <O>Thank you for your message. We will get back to you as soon as possible.</O>,
		"sv": () => <O>Thank you for your message. We will get back to you as soon as possible.</O>,
	},

	"259c6c3ca64a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kontakt information</O>,
		"de": () => <O>Contact information</O>,
		"en": () => <O>Contact information</O>,
		"no": () => <O>Contact information</O>,
		"sv": () => <O>Contact information</O>,
	},

	"da0d96d84012": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Du kan kontakte os direkte her, eller med nedenstående info</O>,
		"de": () => <O>You can contact us here or with the below info</O>,
		"en": () => <O>You can contact us here or with the below info</O>,
		"no": () => <O>You can contact us here or with the below info</O>,
		"sv": () => <O>You can contact us here or with the below info</O>,
	},

	"3f44b41140fa": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>GEN-TILDEL</O>,
		"de": () => <O>RE-ASSIGN</O>,
		"en": () => <O>RE-ASSIGN</O>,
		"no": () => <O>RE-ASSIGN</O>,
		"sv": () => <O>RE-ASSIGN</O>,
	},

	"927a8ee1dc4d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Upload file</O>,
		"de": () => <O>Upload file</O>,
		"en": () => <O>Upload file</O>,
		"no": () => <O>Upload file</O>,
		"sv": () => <O>Upload file</O>,
	},

	"8e61e5a54dae": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Upload</O>,
		"de": () => <O>Upload</O>,
		"en": () => <O>Upload</O>,
		"no": () => <O>Upload</O>,
		"sv": () => <O>Upload</O>,
	},

	"de183267960b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> filer</O>,
		"de": () => <O> files</O>,
		"en": () => <O> files</O>,
		"no": () => <O> files</O>,
		"sv": () => <O> files</O>,
	},

	"283c06ec2aff": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Slip for at placere filerne her</O>,
		"de": () => <O>Release to drop the files here</O>,
		"en": () => <O>Release to drop the files here</O>,
		"no": () => <O>Release to drop the files here</O>,
		"sv": () => <O>Release to drop the files here</O>,
	},

	"33ba001561d5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Browse</O>,
		"de": () => <O>Browse</O>,
		"en": () => <O>Browse</O>,
		"no": () => <O>Browse</O>,
		"sv": () => <O>Browse</O>,
	},

	"784ce1cb09bc": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Mulige formater: </O>,
		"de": () => <O>Supported formates: </O>,
		"en": () => <O>Supported formates: </O>,
		"no": () => <O>Supported formates: </O>,
		"sv": () => <O>Supported formates: </O>,
	},

	"7852b9b29737": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Slet logo</O>,
		"de": () => <O>Delete logo</O>,
		"en": () => <O>Delete logo</O>,
		"no": () => <O>Delete logo</O>,
		"sv": () => <O>Delete logo</O>,
	},

	"4ada977548f4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Gem</O>,
		"de": () => <O>Save</O>,
		"en": () => <O>Save</O>,
		"no": () => <O>Save</O>,
		"sv": () => <O>Save</O>,
	},

	"aaf873e9980a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Compliance Plan</O>,
		"de": () => <O>Compliance Plan</O>,
		"en": () => <O>Compliance Plan</O>,
		"no": () => <O>Compliance Plan</O>,
		"sv": () => <O>Compliance Plan</O>,
	},

	"2d1790f0fb5c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Premium</O>,
		"de": () => <O>Premium plan</O>,
		"en": () => <O>Premium plan</O>,
		"no": () => <O>Premium plan</O>,
		"sv": () => <O>Premium plan</O>,
	},

	"0f1def892e55": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Upload logo</O>,
		"de": () => <O>Upload logo</O>,
		"en": () => <O>Upload logo</O>,
		"no": () => <O>Upload logo</O>,
		"sv": () => <O>Upload logo</O>,
	},

	"2e3b63f297e8": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": (LL) => <O>Har du nogle spørgsmål? Kig efter svaret i vores <a href={LL('/faq')} alt='faq'>FAQ</a></O>,
		"de": (LL) => <O>Do you have some questions? Have a look at our <a href={LL('/faq')} alt='faq'>FAQ</a></O>,
		"en": (LL) => <O>Do you have some questions? Have a look at our <a href={LL('/faq')} alt='faq'>FAQ</a></O>,
		"no": (LL) => <O>Do you have some questions? Have a look at our <a href={LL('/faq')} alt='faq'>FAQ</a></O>,
		"sv": (LL) => <O>Do you have some questions? Have a look at our <a href={LL('/faq')} alt='faq'>FAQ</a></O>,
	},

	"1545790374b6": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>+45 33 11 19 00</O>,
		"de": () => <O>+45 33 11 19 00</O>,
		"en": () => <O>+45 33 11 19 00</O>,
		"no": () => <O>+45 33 11 19 00</O>,
		"sv": () => <O>+45 33 11 19 00</O>,
	},

	"5f78fc0b9f92": {
		"da": () => <O>info@pentus.dk</O>,
		"de": () => <O>info@pentus.dk</O>,
		"en": () => <O>info@pentus.dk</O>,
		"no": () => <O>info@pentus.dk</O>,
		"sv": () => <O>info@pentus.dk</O>,
	},

	"8cb0bd5d2083": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Din kontaktinformation</O>,
		"de": () => <O>Your contact info</O>,
		"en": () => <O>Your contact info</O>,
		"no": () => <O>Your contact info</O>,
		"sv": () => <O>Your contact info</O>,
	},

	"38e941b1feb8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Fornavn</O>,
		"de": () => <O>First name</O>,
		"en": () => <O>First name</O>,
		"no": () => <O>First name</O>,
		"sv": () => <O>First name</O>,
	},

	"f2873726a713": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Efternavn</O>,
		"de": () => <O>Last name</O>,
		"en": () => <O>Last name</O>,
		"no": () => <O>Last name</O>,
		"sv": () => <O>Last name</O>,
	},

	"baf2c2d582d4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>E-mail</O>,
		"de": () => <O>E-mail</O>,
		"en": () => <O>E-mail</O>,
		"no": () => <O>E-mail</O>,
		"sv": () => <O>E-mail</O>,
	},

	"2d8517bf152c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Telefonnummer</O>,
		"de": () => <O>Phone number</O>,
		"en": () => <O>Phone number</O>,
		"no": () => <O>Phone number</O>,
		"sv": () => <O>Phone number</O>,
	},

	"54880c38c860": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Telefonen er åben</O>,
		"de": () => <O>phone is open 24/7</O>,
		"en": () => <O>phone is open 24/7</O>,
		"no": () => <O>phone is open 24/7</O>,
		"sv": () => <O>phone is open 24/7</O>,
	},

	"a32f5bbe4a7e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Danmark</O>,
		"de": () => <O>Denmark</O>,
		"en": () => <O>Denmark</O>,
		"no": () => <O>Denmark</O>,
		"sv": () => <O>Denmark</O>,
	},

	"a11a84624fb9": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Om Pentus</O>,
		"de": () => <O>About Pentus</O>,
		"en": () => <O>About Pentus</O>,
		"no": () => <O>About Pentus</O>,
		"sv": () => <O>About Pentus</O>,
	},

	"d75583ba45c8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Beskyt integriteten i din organisation</O>,
		"de": () => <O>Safeguarding Your Organization's Integrity</O>,
		"en": () => <O>Safeguarding Your Organization's Integrity</O>,
		"no": () => <O>Safeguarding Your Organization's Integrity</O>,
		"sv": () => <O>Safeguarding Your Organization's Integrity</O>,
	},

	"800af4e3b234": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"da": () => <O>Sider</O>,
		"de": () => <O>Pages</O>,
		"en": () => <O>Pages</O>,
		"no": () => <O>Pages</O>,
		"sv": () => <O>Pages</O>,
	},

	"77fbabe9c3d3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Information</O>,
		"de": () => <O>Information</O>,
		"en": () => <O>Information</O>,
		"no": () => <O>Information</O>,
		"sv": () => <O>Information</O>,
	},

	"a46011adbf80": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Brugsbetingelser</O>,
		"de": () => <O>Terms of use</O>,
		"en": () => <O>Terms of use</O>,
		"no": () => <O>Terms of use</O>,
		"sv": () => <O>Terms of use</O>,
	},

	"2935c3969d3f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Privatlivspolitik</O>,
		"de": () => <O>Privacy policy</O>,
		"en": () => <O>Privacy policy</O>,
		"no": () => <O>Privacy policy</O>,
		"sv": () => <O>Privacy policy</O>,
	},

	"a8cecea7e0c1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Sprog</O>,
		"de": () => <O>Language</O>,
		"en": () => <O>Language</O>,
		"no": () => <O>Language</O>,
		"sv": () => <O>Language</O>,
	},

	"b62240d2bdcc": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Drag & drop filer eller </O>,
		"de": () => <O>Drag & drop files or </O>,
		"en": () => <O>Drag & drop files or </O>,
		"no": () => <O>Drag & drop files or </O>,
		"sv": () => <O>Drag & drop files or </O>,
	},

	"40cf60bea0a5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Alle filer tilknyttet indberetningen</O>,
		"de": () => <O>All files beloning to the entry</O>,
		"en": () => <O>All files beloning to the entry</O>,
		"no": () => <O>All files beloning to the entry</O>,
		"sv": () => <O>All files beloning to the entry</O>,
	},

	"377ce9d34b38": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Dokumenter</O>,
		"de": () => <O>Documents</O>,
		"en": () => <O>Documents</O>,
		"no": () => <O>Documents</O>,
		"sv": () => <O>Documents</O>,
	},

	"408d263a836a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Billeder</O>,
		"de": () => <O>Images</O>,
		"en": () => <O>Images</O>,
		"no": () => <O>Images</O>,
		"sv": () => <O>Images</O>,
	},

	"b869a5f24597": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> fil</O>,
		"de": () => <O> file</O>,
		"en": () => <O> file</O>,
		"no": () => <O> file</O>,
		"sv": () => <O> file</O>,
	},

	"195c796cfbf6": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vedhæftede filer</O>,
		"de": () => <O>Attached files</O>,
		"en": () => <O>Attached files</O>,
		"no": () => <O>Attached files</O>,
		"sv": () => <O>Attached files</O>,
	},

	"2da2a08dd5de": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Andre filer</O>,
		"de": () => <O>Other files</O>,
		"en": () => <O>Other files</O>,
		"no": () => <O>Other files</O>,
		"sv": () => <O>Other files</O>,
	},

	"a7874f2c0307": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Mediefiler</O>,
		"de": () => <O>Media files</O>,
		"en": () => <O>Media files</O>,
		"no": () => <O>Media files</O>,
		"sv": () => <O>Media files</O>,
	},

	"d4cede228579": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vælg rolle</O>,
		"de": () => <O>Choose role</O>,
		"en": () => <O>Choose role</O>,
		"no": () => <O>Choose role</O>,
		"sv": () => <O>Choose role</O>,
	},

	"7a627ef1611f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Roller</O>,
		"de": () => <O>Roles</O>,
		"en": () => <O>Roles</O>,
		"no": () => <O>Roles</O>,
		"sv": () => <O>Roles</O>,
	},

	"9792028b4254": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Se indberetning
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        See entry
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        See entry
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        See entry
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        See entry
                                </O>
                        );
                },
	},

	"26f236960a6f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Bruger indberetninger</O>,
		"de": () => <O>user entries</O>,
		"en": () => <O>user entries</O>,
		"no": () => <O>user entries</O>,
		"sv": () => <O>user entries</O>,
	},

	"d31d00f1fc7e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Virksomhedsindberetninger</O>,
		"de": () => <O>company entries</O>,
		"en": () => <O>company entries</O>,
		"no": () => <O>company entries</O>,
		"sv": () => <O>company entries</O>,
	},

	"0344a70a789e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Næste frist</O>,
		"de": () => <O>Deadline</O>,
		"en": () => <O>Deadline</O>,
		"no": () => <O>Deadline</O>,
		"sv": () => <O>Deadline</O>,
	},

	"42de32bf0676": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Seneste aktivitet</O>,
		"de": () => <O>Latest activity</O>,
		"en": () => <O>Latest activity</O>,
		"no": () => <O>Latest activity</O>,
		"sv": () => <O>Latest activity</O>,
	},

	"50d766c1801c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Dette felt skal udfyldes</O>,
		"de": () => <O>This is a required field</O>,
		"en": () => <O>This is a required field</O>,
		"no": () => <O>This is a required field</O>,
		"sv": () => <O>This is a required field</O>,
	},

	"5470d2cefb7d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Firmaadresse mangler</O>,
		"de": () => <O>Company address is required</O>,
		"en": () => <O>Company address is required</O>,
		"no": () => <O>Company address is required</O>,
		"sv": () => <O>Company address is required</O>,
	},

	"1a9c4ae0b7f0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ikke en valid e-mail</O>,
		"de": () => <O>Not a valid email</O>,
		"en": () => <O>Not a valid email</O>,
		"no": () => <O>Not a valid email</O>,
		"sv": () => <O>Not a valid email</O>,
	},

	"735e5c528310": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Brugernavn</O>,
		"de": () => <O>Username</O>,
		"en": () => <O>Username</O>,
		"no": () => <O>Username</O>,
		"sv": () => <O>Username</O>,
	},

	"073ab3b900d3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Navn</O>,
		"de": () => <O>Name</O>,
		"en": () => <O>Name</O>,
		"no": () => <O>Name</O>,
		"sv": () => <O>Name</O>,
	},

	"541dcfc2a1f0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Firma</O>,
		"de": () => <O>Company</O>,
		"en": () => <O>Company</O>,
		"no": () => <O>Company</O>,
		"sv": () => <O>Company</O>,
	},

	"3255ea79d06f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>E-mail</O>,
		"de": () => <O>E-Mail</O>,
		"en": () => <O>E-Mail</O>,
		"no": () => <O>E-Mail</O>,
		"sv": () => <O>E-Mail</O>,
	},

	"3dc52a4dfdde": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>E-mail igen</O>,
		"de": () => <O>E-Mail again</O>,
		"en": () => <O>E-Mail again</O>,
		"no": () => <O>E-Mail again</O>,
		"sv": () => <O>E-Mail again</O>,
	},

	"2028584c34c5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilmeld dig vores nyhedsbrev</O>,
		"de": () => <O>Sign up for our newsletter</O>,
		"en": () => <O>Sign up for our newsletter</O>,
		"no": () => <O>Sign up for our newsletter</O>,
		"sv": () => <O>Sign up for our newsletter</O>,
	},

	"484f9573380d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Adgangskode</O>,
		"de": () => <O>Password</O>,
		"en": () => <O>Password</O>,
		"no": () => <O>Password</O>,
		"sv": () => <O>Password</O>,
	},

	"cbbc12f573a8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kaldenavn </O>,
		"de": () => <O>Screen name </O>,
		"en": () => <O>Screen name </O>,
		"no": () => <O>Screen name </O>,
		"sv": () => <O>Screen name </O>,
	},

	"a4bac02dddae": {
		"da": () => {
			return (
				<O>
					Dette er det navn, der vil blive vist for andre brugere af Pentus
				</O>
			);
		},
		"de": () => {
			return (
				<O>
					This is the name that will be displayed to other users of
					Pentus
				</O>
			);
		},
		"en": () => {
			return (
				<O>
					This is the name that will be displayed to other users of
					Pentus
				</O>
			);
		},
		"no": () => {
			return (
				<O>
					This is the name that will be displayed to other users of
					Pentus
				</O>
			);
		},
		"sv": () => {
			return (
				<O>
					This is the name that will be displayed to other users of
					Pentus
				</O>
			);
		},
	},

	"adf8a7414a42": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Adgangskode igen</O>,
		"de": () => <O>Password again</O>,
		"en": () => <O>Password again</O>,
		"no": () => <O>Password again</O>,
		"sv": () => <O>Password again</O>,
	},

	"f14b509798dd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Nulstil adgangskode</O>,
		"de": () => <O>Reset password</O>,
		"en": () => <O>Reset password</O>,
		"no": () => <O>Reset password</O>,
		"sv": () => <O>Reset password</O>,
	},

	"8b9998b05ba5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Lav ny adgangskode her.</O>,
		"de": () => <O>Create new password here.</O>,
		"en": () => <O>Create new password here.</O>,
		"no": () => <O>Create new password here.</O>,
		"sv": () => <O>Create new password here.</O>,
	},

	"f7defb08cf70": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Gem adgangskode</O>,
		"de": () => <O>Save password</O>,
		"en": () => <O>Save password</O>,
		"no": () => <O>Save password</O>,
		"sv": () => <O>Save password</O>,
	},

	"ebc71f862240": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Har du allerede en brugerkonto?</O>,
		"de": () => <O>Already have an account?</O>,
		"en": () => <O>Already have an account?</O>,
		"no": () => <O>Already have an account?</O>,
		"sv": () => <O>Already have an account?</O>,
	},

	"28c53487292f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Adgangskoderne er ikke ens</O>,
		"de": () => <O>Passwords do not match</O>,
		"en": () => <O>Passwords do not match</O>,
		"no": () => <O>Passwords do not match</O>,
		"sv": () => <O>Passwords do not match</O>,
	},

	"5d27f844f291": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> Adgangskoden skal være mindst 8 tegn og indeholde mindst 1 stort bogstav, 1 lille bogstav og 1 specialtegn.</O>,
		"de": () => <O>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</O>,
		"en": () => <O>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</O>,
		"no": () => <O>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</O>,
		"sv": () => <O>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</O>,
	},

	"11aa8134ce58": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>E-mails matcher ikke</O>,
		"de": () => <O>Emails do not match</O>,
		"en": () => <O>Emails do not match</O>,
		"no": () => <O>Emails do not match</O>,
		"sv": () => <O>Emails do not match</O>,
	},

	"4a23f8a1b752": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Opret bruger</O>,
		"de": () => <O>Sign up</O>,
		"en": () => <O>Sign up</O>,
		"no": () => <O>Sign up</O>,
		"sv": () => <O>Sign up</O>,
	},

	"ac75c1899e9b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Månedlig</O>,
		"de": () => <O>Monthly</O>,
		"en": () => <O>Monthly</O>,
		"no": () => <O>Monthly</O>,
		"sv": () => <O>Monthly</O>,
	},

	"63774c32574a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Intropris</O>,
		"de": () => <O>Intro price</O>,
		"en": () => <O>Intro price</O>,
		"no": () => <O>Intro price</O>,
		"sv": () => <O>Intro price</O>,
	},

	"a6080ac70868": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>måneder</O>,
		"de": () => <O>months</O>,
		"en": () => <O>months</O>,
		"no": () => <O>months</O>,
		"sv": () => <O>months</O>,
	},

	"3d261ea912c4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>10% rabat</O>,
		"de": () => <O>10% discount</O>,
		"en": () => <O>10% discount</O>,
		"no": () => <O>10% discount</O>,
		"sv": () => <O>10% discount</O>,
	},

	"6fc9d6daa0aa": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>COMPLIANCE</O>,
		"de": () => <O>COMPLIANCE</O>,
		"en": () => <O>COMPLIANCE</O>,
		"no": () => <O>COMPLIANCE</O>,
		"sv": () => <O>COMPLIANCE</O>,
	},

	"682c2cd3e907": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Vores basispakke med intiutiv brugergrænseflade og 100% overholdelse af lovgivningen.
                                        Dit sikre valg af whistleblower-løsning.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Our basic package with intuitive user experience and 100% compliance with the law.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Our basic package with intuitive user experience and 100% compliance with the law.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Our basic package with intuitive user experience and 100% compliance with the law.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Our basic package with intuitive user experience and 100% compliance with the law.
                                </O>
                        );
                },
	},

	"f7854dd1eee3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Vores toppakke med alle funktionerne fra Compliance-pakken, 5 screeninger af sager om året samt firmabranding.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Our top package with all the features from the Compliance package, 5 case screenings per year and company branding.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Our top package with all the features from the Compliance package, 5 case screenings per year and company branding.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Our top package with all the features from the Compliance package, 5 case screenings per year and company branding.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Our top package with all the features from the Compliance package, 5 case screenings per year and company branding.
                                </O>
                        );
                },
	},

	"a8d5e7033813": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Køb nu</O>,
		"de": () => <O>Buy</O>,
		"en": () => <O>Buy</O>,
		"no": () => <O>Buy</O>,
		"sv": () => <O>Buy</O>,
	},

	"576100adc06f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Efter introperioden er udløbet vil premium koste</O>,
		"de": () => <O>When the introduction period ends, premium will be</O>,
		"en": () => <O>When the introduction period ends, premium will be</O>,
		"no": () => <O>When the introduction period ends, premium will be</O>,
		"sv": () => <O>When the introduction period ends, premium will be</O>,
	},

	"4d1cc0c7490e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Efter introperioden er udløbet vil compliance koste</O>,
		"de": () => <O>When the introduction periods ends, compliance will be</O>,
		"en": () => <O>When the introduction periods end, compliance will be</O>,
		"no": () => <O>When the introduction periods end, compliance will be</O>,
		"sv": () => <O>When the introduction periods end, compliance will be</O>,
	},

	"da8017b9fd11": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>kr / måneden</O>,
		"de": () => <O>kr / month</O>,
		"en": () => <O>kr / month</O>,
		"no": () => <O>kr / month</O>,
		"sv": () => <O>kr / month</O>,
	},

	"2c71c9ac192c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Nemt og intuitivt</O>,
		"de": () => <O>Easy and intuitive</O>,
		"en": () => <O>Easy and intuitive</O>,
		"no": () => <O>Easy and intuitive</O>,
		"sv": () => <O>Easy and intuitive</O>,
	},

	"a6bd1cdf50e5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ubegrænset antal indberetninger</O>,
		"de": () => <O>Unlimited cases</O>,
		"en": () => <O>Unlimited cases</O>,
		"no": () => <O>Unlimited cases</O>,
		"sv": () => <O>Unlimited cases</O>,
	},

	"d7fd80636c81": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ubegrænset antal interne og eksterne sagsbehandlere</O>,
		"de": () => <O>Unlimited case workers and external counsellors</O>,
		"en": () => <O>Unlimited case workers and external counsellors</O>,
		"no": () => <O>Unlimited case workers and external counsellors</O>,
		"sv": () => <O>Unlimited case workers and external counsellors</O>,
	},

	"05ffded21449": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Skræddersyede whistleblower-betingelser og tekst til medarbejderhåndbogen</O>,
		"de": () => <O>Tailor-made whistleblower terms and text for employee handbook</O>,
		"en": () => <O>Tailor-made whistleblower terms and text for employee handbook</O>,
		"no": () => <O>Tailor-made whistleblower terms and text for employee handbook</O>,
		"sv": () => <O>Tailor-made whistleblower terms and text for employee handbook</O>,
	},

	"60a3341731b3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Årlig</O>,
		"de": () => <O>Yearly</O>,
		"en": () => <O>Yearly</O>,
		"no": () => <O>Yearly</O>,
		"sv": () => <O>Yearly</O>,
	},

	"0aa0906923e6": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilmeld dig Pentus</O>,
		"de": () => <O>Sign up for Pentus</O>,
		"en": () => <O>Sign up for Pentus</O>,
		"no": () => <O>Sign up for Pentus</O>,
		"sv": () => <O>Sign up for Pentus</O>,
	},

	"98029f14349e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Du vil blive kontaktet inden de 14 dages prøveperiodes udløb ifht. betaling.</O>,
		"de": () => <O>Du vil blive kontaktet inden de 14 dages prøveperiodes udløb ifht. betaling.</O>,
		"en": () => <O>Du vil blive kontaktet inden de 14 dages prøveperiodes udløb ifht. betaling.</O>,
		"no": () => <O>Du vil blive kontaktet inden de 14 dages prøveperiodes udløb ifht. betaling.</O>,
		"sv": () => <O>Du vil blive kontaktet inden de 14 dages prøveperiodes udløb ifht. betaling.</O>,
	},

	"6d7f4b82dc00": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Redigér bruger</O>,
		"de": () => <O>Edit User</O>,
		"en": () => <O>Edit User</O>,
		"no": () => <O>Edit User</O>,
		"sv": () => <O>Edit User</O>,
	},

	"5ba64ca37e6d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetning</O>,
		"de": () => <O>Entry</O>,
		"en": () => <O>Entry</O>,
		"no": () => <O>Entry</O>,
		"sv": () => <O>Entry</O>,
	},

	"f08c6fc5e049": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Lydfil</O>,
		"de": () => <O>Audio File</O>,
		"en": () => <O>Audio File</O>,
		"no": () => <O>Audio File</O>,
		"sv": () => <O>Audio File</O>,
	},

	"59cab0a24969": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilføj bruger</O>,
		"de": () => <O>Add User</O>,
		"en": () => <O>Add User</O>,
		"no": () => <O>Add User</O>,
		"sv": () => <O>Add User</O>,
	},

	"6cc54ec31fac": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Afventende invitationer</O>,
		"de": () => <O>Pending invites</O>,
		"en": () => <O>Pending invites</O>,
		"no": () => <O>Pending invites</O>,
		"sv": () => <O>Pending invites</O>,
	},

	"cb9040e39b0b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Afventende</O>,
		"de": () => <O>Pending</O>,
		"en": () => <O>Pending</O>,
		"no": () => <O>Pending</O>,
		"sv": () => <O>Pending</O>,
	},

	"47933dd891fc": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Send igen</O>,
		"de": () => <O>Resend</O>,
		"en": () => <O>Resend</O>,
		"no": () => <O>Resend</O>,
		"sv": () => <O>Resend</O>,
	},

	"7b6bf2995074": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Annullér invitation</O>,
		"de": () => <O>Cancel Invitation</O>,
		"en": () => <O>Cancel Invitation</O>,
		"no": () => <O>Cancel Invitation</O>,
		"sv": () => <O>Cancel Invitation</O>,
	},

	"fd93ef812ef7": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Admin</O>,
		"de": () => <O>Admin</O>,
		"en": () => <O>Admin</O>,
		"no": () => <O>Admin</O>,
		"sv": () => <O>Admin</O>,
	},

	"c4faecec1303": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Intern</O>,
		"de": () => <O>Internal</O>,
		"en": () => <O>Internal</O>,
		"no": () => <O>Internal</O>,
		"sv": () => <O>Internal</O>,
	},

	"e274fc04233d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ekstern</O>,
		"de": () => <O>External</O>,
		"en": () => <O>External</O>,
		"no": () => <O>External</O>,
		"sv": () => <O>External</O>,
	},

	"36fa68747fc8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Intern sagsbehandler</O>,
		"de": () => <O>Internal case worker</O>,
		"en": () => <O>Internal case worker</O>,
		"no": () => <O>Internal case worker</O>,
		"sv": () => <O>Internal case worker</O>,
	},

	"62d578aa8836": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ekstern sagsbehandler</O>,
		"de": () => <O>External case worker</O>,
		"en": () => <O>External case worker</O>,
		"no": () => <O>External case worker</O>,
		"sv": () => <O>External case worker</O>,
	},

	"d473b6abc695": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>Administrator (Admin) har adgang til: Fuld brugeradministration, generering af links, betalingsmuligheder, whistleblower-politikker mv. Administrator kan ikke få adgang til indholdet i indberetningerne, medmindre Administrator er tildelt som sagsbehandler på en indberetning.</O>
                        );
                },
		"de": () => {
                        return (
                                <O>Access to: full user administration, generate links, see entries (open and closed), payment options,
                                        whistleblowerpolicies.
                                        Administrator cannot access the individual entries unless assigned as caseworker.</O>
                        );
                },
		"en": () => {
                        return (
                                <O>Access to: full user administration, generate links, see entries (open and closed), payment options,
                                        whistleblowerpolicies.
                                        Administrator cannot access the individual entries unless assigned as caseworker.</O>
                        );
                },
		"no": () => {
                        return (
                                <O>Access to: full user administration, generate links, see entries (open and closed), payment options,
                                        whistleblowerpolicies.
                                        Administrator cannot access the individual entries unless assigned as caseworker.</O>
                        );
                },
		"sv": () => {
                        return (
                                <O>Access to: full user administration, generate links, see entries (open and closed), payment options,
                                        whistleblowerpolicies.
                                        Administrator cannot access the individual entries unless assigned as caseworker.</O>
                        );
                },
	},

	"75e473c467d8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O> Dette er organisationens interne sagsbehandlere (f.eks. administrerende direktør, HR, juridisk rådgiver, CFO m.fl.) - den interne sagsbehandler har adgang til alle sider, der er tildelt dem. Den interne sagsbehandler kan kommentere og uploade materiale til siderne og videresende indberetninger til andre sagsbehandlere (eksterne / interne).</O>
                        );
                },
		"de": () => {
                        return (
                                <O>This is the organizations internal caseworkers (e.g. Managing director, HR, legal counsel, CFO a.o.) - the
                                        internal caseworker has access to all entries assigned to them. The internal caseworker can comment and
                                        upload material on entries and forward entries to other caseworkers (external/internal).</O>
                        );
                },
		"en": () => {
                        return (
                                <O>This is the organizations internal caseworkers (e.g. Managing director, HR, legal counsel, CFO a.o.) - the
                                        internal caseworker has access to all entries assigned to them. The internal caseworker can comment and
                                        upload material on entries and forward entries to other caseworkers (external/internal).</O>
                        );
                },
		"no": () => {
                        return (
                                <O>This is the organizations internal caseworkers (e.g. Managing director, HR, legal counsel, CFO a.o.) - the
                                        internal caseworker has access to all entries assigned to them. The internal caseworker can comment and
                                        upload material on entries and forward entries to other caseworkers (external/internal).</O>
                        );
                },
		"sv": () => {
                        return (
                                <O>This is the organizations internal caseworkers (e.g. Managing director, HR, legal counsel, CFO a.o.) - the
                                        internal caseworker has access to all entries assigned to them. The internal caseworker can comment and
                                        upload material on entries and forward entries to other caseworkers (external/internal).</O>
                        );
                },
	},

	"322e9fcbb095": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>Dette er organisationens eksterne sagsbehandlere (f.eks. juridisk rådgiver eller konsulenter). Den eksterne sagsbehandler har adgang til alle sider, der er tildelt dem. Den interne sagsbehandler kan kommentere og uploade materiale til siderne og videresende indberetninger til andre sagsbehandlere (eksterne / interne). Bemærk venligst, at Pentus ikke er ansvarlig for eventuelle juridiske gebyrer, denne mulighed kan medføre.</O>
                        );
                },
		"de": () => {
                        return (
                                <O>This is the organizations external caseworkers (e.g. Legal counsel or consultants). the external caseworker
                                        has access to all entries assigned to them. The internal caseworker can comment and upload material on
                                        entries and forward entries to other caseworkers (external/internal). Please advise that Pentus is not liable
                                        for any legal fees this option may incur.</O>
                        );
                },
		"en": () => {
                        return (
                                <O>This is the organizations external caseworkers (e.g. Legal counsel or consultants). the external caseworker
                                        has access to all entries assigned to them. The internal caseworker can comment and upload material on
                                        entries and forward entries to other caseworkers (external/internal). Please advise that Pentus is not liable
                                        for any legal fees this option may incur.</O>
                        );
                },
		"no": () => {
                        return (
                                <O>This is the organizations external caseworkers (e.g. Legal counsel or consultants). the external caseworker
                                        has access to all entries assigned to them. The internal caseworker can comment and upload material on
                                        entries and forward entries to other caseworkers (external/internal). Please advise that Pentus is not liable
                                        for any legal fees this option may incur.</O>
                        );
                },
		"sv": () => {
                        return (
                                <O>This is the organizations external caseworkers (e.g. Legal counsel or consultants). the external caseworker
                                        has access to all entries assigned to them. The internal caseworker can comment and upload material on
                                        entries and forward entries to other caseworkers (external/internal). Please advise that Pentus is not liable
                                        for any legal fees this option may incur.</O>
                        );
                },
	},

	"11104f0a38b0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Firmanavn</O>,
		"de": () => <O>Company Name</O>,
		"en": () => <O>Company Name</O>,
		"no": () => <O>Company Name</O>,
		"sv": () => <O>Company Name</O>,
	},

	"d3c0edfaf8c0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>CVR</O>,
		"de": () => <O>CVR</O>,
		"en": () => <O>CVR</O>,
		"no": () => <O>CVR</O>,
		"sv": () => <O>CVR</O>,
	},

	"a6c305a06e9c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Firmaadresse</O>,
		"de": () => <O>Company address</O>,
		"en": () => <O>Company address</O>,
		"no": () => <O>Company address</O>,
		"sv": () => <O>Company address</O>,
	},

	"770fa23ad39a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Adresse</O>,
		"de": () => <O>Address</O>,
		"en": () => <O>Address</O>,
		"no": () => <O>Address</O>,
		"sv": () => <O>Address</O>,
	},

	"9dc086bcd9fa": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Postnummer</O>,
		"de": () => <O>Zipcode</O>,
		"en": () => <O>Zipcode</O>,
		"no": () => <O>Zipcode</O>,
		"sv": () => <O>Zipcode</O>,
	},

	"62a492bcffb7": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>By</O>,
		"de": () => <O>City</O>,
		"en": () => <O>City</O>,
		"no": () => <O>City</O>,
		"sv": () => <O>City</O>,
	},

	"cb5057b9da38": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Land</O>,
		"de": () => <O>Country</O>,
		"en": () => <O>Country</O>,
		"no": () => <O>Country</O>,
		"sv": () => <O>Country</O>,
	},

	"ca4a0db9d8fb": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>opdater firmainformationer</O>,
		"de": () => <O>update company details</O>,
		"en": () => <O>update company details</O>,
		"no": () => <O>update company details</O>,
		"sv": () => <O>update company details</O>,
	},

	"e5b37cb7fded": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indtast den 6-cifrede kode du modtog på </O>,
		"de": () => <O>Insert the 6 digit code you received on </O>,
		"en": () => <O>Insert the 6 digit code you received on </O>,
		"no": () => <O>Insert the 6 digit code you received on </O>,
		"sv": () => <O>Insert the 6 digit code you received on </O>,
	},

	"45412351e2bd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>Dette hjælper os med at holde din konto sikker
                                        <br />
                                        og for at bekræfte din identitet</O>
                        );
                },
		"de": () => {
                        return (
                                <O>This helps us keep your account safe
                                        <br />
                                        and to verify your identity</O>
                        );
                },
		"en": () => {
                        return (
                                <O>This helps us keep your account safe
                                        <br />
                                        and to verify your identity</O>
                        );
                },
		"no": () => {
                        return (
                                <O>This helps us keep your account safe
                                        <br />
                                        and to verify your identity</O>
                        );
                },
		"sv": () => {
                        return (
                                <O>This helps us keep your account safe
                                        <br />
                                        and to verify your identity</O>
                        );
                },
	},

	"ddf32601df47": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indtast 2-faktor godkendelseskode</O>,
		"de": () => <O>Enter 2-step verification code</O>,
		"en": () => <O>Enter 2-step verification code</O>,
		"no": () => <O>Enter 2-step verification code</O>,
		"sv": () => <O>Enter 2-step verification code</O>,
	},

	"c9b162f06366": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Forkert kode</O>,
		"de": () => <O>Incorrect code</O>,
		"en": () => <O>Incorrect code</O>,
		"no": () => <O>Incorrect code</O>,
		"sv": () => <O>Incorrect code</O>,
	},

	"bb6bd84b4fdb": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Modtag ny kode</O>,
		"de": () => <O>Receive a new code</O>,
		"en": () => <O>Receive a new code</O>,
		"no": () => <O>Receive a new code</O>,
		"sv": () => <O>Receive a new code</O>,
	},

	"9fdb2ac6ae91": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Bekræft</O>,
		"de": () => <O>Confirm</O>,
		"en": () => <O>Confirm</O>,
		"no": () => <O>Confirm</O>,
		"sv": () => <O>Confirm</O>,
	},

	"d25ddc7e1435": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>2-trins vertifikation</O>,
		"de": () => <O>2-step Verification</O>,
		"en": () => <O>2-step Verification</O>,
		"no": () => <O>2-step Verification</O>,
		"sv": () => <O>2-step Verification</O>,
	},

	"87754474e899": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hej</O>,
		"de": () => <O>Hi</O>,
		"en": () => <O>Hi</O>,
		"no": () => <O>Hi</O>,
		"sv": () => <O>Hi</O>,
	},

	"c35d9e86cb99": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Af sikkerhedsmæssige årsager sender vi dig en kode</O>,
		"de": () => <O>For security reasons we will send you a code</O>,
		"en": () => <O>For security reasons we will send you a code</O>,
		"no": () => <O>For security reasons we will send you a code</O>,
		"sv": () => <O>For security reasons we will send you a code</O>,
	},

	"7ca34f259ad5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>som du skal bruge for at logge ind.</O>,
		"de": () => <O>which you will need in order to login.</O>,
		"en": () => <O>which you will need in order to login.</O>,
		"no": () => <O>which you will need in order to login.</O>,
		"sv": () => <O>which you will need in order to login.</O>,
	},

	"62f62d4f085c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvordan vil du gerne modtage koden?</O>,
		"de": () => <O>How would you like to receive the code?</O>,
		"en": () => <O>How would you like to receive the code?</O>,
		"no": () => <O>How would you like to receive the code?</O>,
		"sv": () => <O>How would you like to receive the code?</O>,
	},

	"37ca5a5b76a5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Modtag kode</O>,
		"de": () => <O>Receive code</O>,
		"en": () => <O>Receive code</O>,
		"no": () => <O>Receive code</O>,
		"sv": () => <O>Receive code</O>,
	},

	"0f5d067ec210": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>i en sms</O>,
		"de": () => <O>in an SMS text</O>,
		"en": () => <O>in an SMS text</O>,
		"no": () => <O>in an SMS text</O>,
		"sv": () => <O>in an SMS text</O>,
	},

	"55e5421da1c1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>i en email</O>,
		"de": () => <O>in an email</O>,
		"en": () => <O>in an email</O>,
		"no": () => <O>in an email</O>,
		"sv": () => <O>in an email</O>,
	},

	"91b5986c1177": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Annullér log ind</O>,
		"de": () => <O>Cancel Login</O>,
		"en": () => <O>Cancel Login</O>,
		"no": () => <O>Cancel Login</O>,
		"sv": () => <O>Cancel Login</O>,
	},

	"cd4846163eb1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Annullér</O>,
		"de": () => <O>Cancel</O>,
		"en": () => <O>Cancel</O>,
		"no": () => <O>Cancel</O>,
		"sv": () => <O>Cancel</O>,
	},

	"90451c04ddb9": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Gem bruger</O>,
		"de": () => <O>Save User</O>,
		"en": () => <O>Save User</O>,
		"no": () => <O>Save User</O>,
		"sv": () => <O>Save User</O>,
	},

	"bc31c15cbcf3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vælg venligst en ny status til sagen</O>,
		"de": () => <O>Please pick a new status for the entry</O>,
		"en": () => <O>Please pick a new status for the entry</O>,
		"no": () => <O>Please pick a new status for the entry</O>,
		"sv": () => <O>Please pick a new status for the entry</O>,
	},

	"031be94cf23a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ny</O>,
		"de": () => <O>New</O>,
		"en": () => <O>New</O>,
		"no": () => <O>New</O>,
		"sv": () => <O>New</O>,
	},

	"7d684776044a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Gennemført</O>,
		"de": () => <O>Processed</O>,
		"en": () => <O>Processed</O>,
		"no": () => <O>Processed</O>,
		"sv": () => <O>Processed</O>,
	},

	"f4bdaf4befec": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Videregivet</O>,
		"de": () => <O>Passed on</O>,
		"en": () => <O>Passed on</O>,
		"no": () => <O>Passed on</O>,
		"sv": () => <O>Passed on</O>,
	},

	"2527e3b3a185": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Afsluttet</O>,
		"de": () => <O>Closed</O>,
		"en": () => <O>Closed</O>,
		"no": () => <O>Closed</O>,
		"sv": () => <O>Closed</O>,
	},

	"266922258c91": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Fuldfør</O>,
		"de": () => <O>Submit</O>,
		"en": () => <O>Submit</O>,
		"no": () => <O>Submit</O>,
		"sv": () => <O>Submit</O>,
	},

	"1e50370dc2be": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> Da denne indberetning er afsluttet, kan den ikke redigeres</O>,
		"de": () => <O>Since this entry is closed, it cannot be edited</O>,
		"en": () => <O>Since this entry is closed, it cannot be edited</O>,
		"no": () => <O>Since this entry is closed, it cannot be edited</O>,
		"sv": () => <O>Since this entry is closed, it cannot be edited</O>,
	},

	"98ad4a6019a0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetningslink</O>,
		"de": () => <O>Generate Link</O>,
		"en": () => <O>Generate Link</O>,
		"no": () => <O>Generate Link</O>,
		"sv": () => <O>Generate Link</O>,
	},

	"ce3983ca150a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>INDSTILLINGER</O>,
		"de": () => <O>SETTINGS</O>,
		"en": () => <O>SETTINGS</O>,
		"no": () => <O>SETTINGS</O>,
		"sv": () => <O>SETTINGS</O>,
	},

	"d17b0a1eda5f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>plan</O>,
		"de": () => <O>plan</O>,
		"en": () => <O>plan</O>,
		"no": () => <O>plan</O>,
		"sv": () => <O>plan</O>,
	},

	"cb8ccd39e4d1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>tilføj en note</O>,
		"de": () => <O>added a comment</O>,
		"en": () => <O>added a comment</O>,
		"no": () => <O>added a comment</O>,
		"sv": () => <O>added a comment</O>,
	},

	"7f149fde23f6": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>sent a message</O>,
		"de": () => <O>sent a message</O>,
		"en": () => <O>sent a message</O>,
		"no": () => <O>sent a message</O>,
		"sv": () => <O>sent a message</O>,
	},

	"5fd84d601346": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>tilgik indberetningen</O>,
		"de": () => <O>accessed entry</O>,
		"en": () => <O>accessed entry</O>,
		"no": () => <O>accessed entry</O>,
		"sv": () => <O>accessed entry</O>,
	},

	"2ba5fbba886d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>slet indberetning</O>,
		"de": () => <O>deleted entry</O>,
		"en": () => <O>deleted entry</O>,
		"no": () => <O>deleted entry</O>,
		"sv": () => <O>deleted entry</O>,
	},

	"da19bcaff635": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>delt indberetning</O>,
		"de": () => <O>shared entry</O>,
		"en": () => <O>shared entry</O>,
		"no": () => <O>shared entry</O>,
		"sv": () => <O>shared entry</O>,
	},

	"e8cdba54b763": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>tilknyttede indberetning </O>,
		"de": () => <O>assigned whistle</O>,
		"en": () => <O>assigned whistle</O>,
		"no": () => <O>assigned whistle</O>,
		"sv": () => <O>assigned whistle</O>,
	},

	"998aa365ef56": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>ændre indberetningens status</O>,
		"de": () => <O>changed entry status</O>,
		"en": () => <O>changed entry status</O>,
		"no": () => <O>changed entry status</O>,
		"sv": () => <O>changed entry status</O>,
	},

	"b507f02180fd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>slet adgang til indberetningen</O>,
		"de": () => <O>deleted entry access</O>,
		"en": () => <O>deleted entry access</O>,
		"no": () => <O>deleted entry access</O>,
		"sv": () => <O>deleted entry access</O>,
	},

	"d27c6b57b4da": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>oprettede indberetningen</O>,
		"de": () => <O>created entry</O>,
		"en": () => <O>created entry</O>,
		"no": () => <O>created entry</O>,
		"sv": () => <O>created entry</O>,
	},

	"ed2786017408": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>slettet fil</O>,
		"de": () => <O>deleted file</O>,
		"en": () => <O>deleted file</O>,
		"no": () => <O>deleted file</O>,
		"sv": () => <O>deleted file</O>,
	},

	"377132f075a9": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>anmodet om filupload</O>,
		"de": () => <O>requested file upload</O>,
		"en": () => <O>requested file upload</O>,
		"no": () => <O>requested file upload</O>,
		"sv": () => <O>requested file upload</O>,
	},

	"ce43004ee5be": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>uploadede filer</O>,
		"de": () => <O>uploaded files</O>,
		"en": () => <O>uploaded files</O>,
		"no": () => <O>uploaded files</O>,
		"sv": () => <O>uploaded files</O>,
	},

	"fe7cafbb2a2a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>med</O>,
		"de": () => <O>with</O>,
		"en": () => <O>with</O>,
		"no": () => <O>with</O>,
		"sv": () => <O>with</O>,
	},

	"49d57b433459": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>til</O>,
		"de": () => <O>to</O>,
		"en": () => <O>to</O>,
		"no": () => <O>to</O>,
		"sv": () => <O>to</O>,
	},

	"565a3ecfffa2": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Whistleblower</O>,
		"de": () => <O>case reporter</O>,
		"en": () => <O>case reporter</O>,
		"no": () => <O>case reporter</O>,
		"sv": () => <O>case reporter</O>,
	},

	"c3d13ce4f258": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tidsstempel</O>,
		"de": () => <O>Timestamp</O>,
		"en": () => <O>Timestamp</O>,
		"no": () => <O>Timestamp</O>,
		"sv": () => <O>Timestamp</O>,
	},

	"286a48926424": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Aktivitet</O>,
		"de": () => <O>Action</O>,
		"en": () => <O>Action</O>,
		"no": () => <O>Action</O>,
		"sv": () => <O>Action</O>,
	},

	"5ff9efab757b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilknyttet kommentar</O>,
		"de": () => <O>Comment</O>,
		"en": () => <O>Comment</O>,
		"no": () => <O>Comment</O>,
		"sv": () => <O>Comment</O>,
	},

	"840459202711": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Brugere</O>,
		"de": () => <O>Users</O>,
		"en": () => <O>Users</O>,
		"no": () => <O>Users</O>,
		"sv": () => <O>Users</O>,
	},

	"614a4c0a5347": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilføj bruger</O>,
		"de": () => <O>Add user</O>,
		"en": () => <O>Add user</O>,
		"no": () => <O>Add user</O>,
		"sv": () => <O>Add user</O>,
	},

	"647280d142d3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Min bruger</O>,
		"de": () => <O>My Account</O>,
		"en": () => <O>My Account</O>,
		"no": () => <O>My Account</O>,
		"sv": () => <O>My Account</O>,
	},

	"d43b9bbe02b8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Firmaindstillinger</O>,
		"de": () => <O>Company Settings</O>,
		"en": () => <O>Company Settings</O>,
		"no": () => <O>Company Settings</O>,
		"sv": () => <O>Company Settings</O>,
	},

	"c1d7c2fb1538": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Links</O>,
		"de": () => <O>Links</O>,
		"en": () => <O>Links</O>,
		"no": () => <O>Links</O>,
		"sv": () => <O>Links</O>,
	},

	"74cf219258ec": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Step 2/2</O>,
		"de": () => <O>Step 2/2</O>,
		"en": () => <O>Step 2/2</O>,
		"no": () => <O>Step 2/2</O>,
		"sv": () => <O>Step 2/2</O>,
	},

	"795abe4d5b86": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Step 3</O>,
		"de": () => <O>Step 3</O>,
		"en": () => <O>Step 3</O>,
		"no": () => <O>Step 3</O>,
		"sv": () => <O>Step 3</O>,
	},

	"4f017600bb81": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indsend din sag</O>,
		"de": () => <O>Submit your issue</O>,
		"en": () => <O>Submit your issue</O>,
		"no": () => <O>Submit your issue</O>,
		"sv": () => <O>Submit your issue</O>,
	},

	"a706f437e696": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vælg behandler af indberetningen</O>,
		"de": () => <O>Entry recipient</O>,
		"en": () => <O>Entry recipient</O>,
		"no": () => <O>Entry recipient</O>,
		"sv": () => <O>Entry recipient</O>,
	},

	"a268bee23d07": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Optag lyd</O>,
		"de": () => <O>record sound</O>,
		"en": () => <O>record sound</O>,
		"no": () => <O>record sound</O>,
		"sv": () => <O>record sound</O>,
	},

	"e05a30db4c07": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Skriv indberetning</O>,
		"de": () => <O>write entry</O>,
		"en": () => <O>write entry</O>,
		"no": () => <O>write entry</O>,
		"sv": () => <O>write entry</O>,
	},

	"880b09d6b72e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ønsk et møde med din behandler</O>,
		"de": () => <O>Request meeting</O>,
		"en": () => <O>Request meeting</O>,
		"no": () => <O>Request meeting</O>,
		"sv": () => <O>Request meeting</O>,
	},

	"0b200d79408d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Anfør fx dage og tidspunkter som vil passe at mødes digitalt eller fysisk med sagsbehandleren af din indberetning</O>,
		"de": () => <O>fill in some details</O>,
		"en": () => <O>fill in some details</O>,
		"no": () => <O>fill in some details</O>,
		"sv": () => <O>fill in some details</O>,
	},

	"cde91ccd93bc": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilbage</O>,
		"de": () => <O>Back</O>,
		"en": () => <O>Back</O>,
		"no": () => <O>Back</O>,
		"sv": () => <O>Back</O>,
	},

	"dfbeaaae86c5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> til indberetningslisten</O>,
		"de": () => <O> to entries list</O>,
		"en": () => <O> to entries list</O>,
		"no": () => <O> to entries list</O>,
		"sv": () => <O> to entries list</O>,
	},

	"bbaf889a1981": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilknyt indberetning til ny sagsbehandler</O>,
		"de": () => <O>Assign whistle</O>,
		"en": () => <O>Assign whistle</O>,
		"no": () => <O>Assign whistle</O>,
		"sv": () => <O>Assign whistle</O>,
	},

	"fcb49c9e9507": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Viser
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Showing
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Showing
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Showing
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Showing
                                </O>
                        );
                },
	},

	"8c0f15a127df": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>ud af </O>,
		"de": () => <O>out of</O>,
		"en": () => <O>out of</O>,
		"no": () => <O>out of</O>,
		"sv": () => <O>out of</O>,
	},

	"9834747ad2a0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>resultater</O>,
		"de": () => <O>results</O>,
		"en": () => <O>results</O>,
		"no": () => <O>results</O>,
		"sv": () => <O>results</O>,
	},

	"288cef8a26d3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Del indberetning</O>,
		"de": () => <O>Share</O>,
		"en": () => <O>Share</O>,
		"no": () => <O>Share</O>,
		"sv": () => <O>Share</O>,
	},

	"74287c1e36ac": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Log</O>,
		"de": () => <O>Logs</O>,
		"en": () => <O>Logs</O>,
		"no": () => <O>Logs</O>,
		"sv": () => <O>Logs</O>,
	},

	"d1affab663c3": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ændre status</O>,
		"de": () => <O>Change Status</O>,
		"en": () => <O>Change Status</O>,
		"no": () => <O>Change Status</O>,
		"sv": () => <O>Change Status</O>,
	},

	"436ce7e31cee": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetnings-ID</O>,
		"de": () => <O>Details</O>,
		"en": () => <O>Details</O>,
		"no": () => <O>Details</O>,
		"sv": () => <O>Details</O>,
	},

	"df2422983c84": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Kategorier</O>,
		"de": () => <O>Categories</O>,
		"en": () => <O>Categories</O>,
		"no": () => <O>Categories</O>,
		"sv": () => <O>Categories</O>,
	},

	"73fa376d3d06": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Type indberetning</O>,
		"de": () => <O>Mode</O>,
		"en": () => <O>Mode</O>,
		"no": () => <O>Mode</O>,
		"sv": () => <O>Mode</O>,
	},

	"b52f24f89537": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Seneste aktivitet</O>,
		"de": () => <O>Last action</O>,
		"en": () => <O>Last action</O>,
		"no": () => <O>Last action</O>,
		"sv": () => <O>Last action</O>,
	},

	"2c54fc873813": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetningsdato</O>,
		"de": () => <O>Entry date</O>,
		"en": () => <O>Entry date</O>,
		"no": () => <O>Entry date</O>,
		"sv": () => <O>Entry date</O>,
	},

	"427441a01fa1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Næste frist</O>,
		"de": () => <O>Next deadline</O>,
		"en": () => <O>Next deadline</O>,
		"no": () => <O>Next deadline</O>,
		"sv": () => <O>Next deadline</O>,
	},

	"1fcbd5731a96": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>dag</O>,
		"de": () => <O>day</O>,
		"en": () => <O>day</O>,
		"no": () => <O>day</O>,
		"sv": () => <O>day</O>,
	},

	"9d7e8a987b72": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>i dag</O>,
		"de": () => <O>today</O>,
		"en": () => <O>today</O>,
		"no": () => <O>today</O>,
		"sv": () => <O>today</O>,
	},

	"0c0f3436f43a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>dage</O>,
		"de": () => <O>days</O>,
		"en": () => <O>days</O>,
		"no": () => <O>days</O>,
		"sv": () => <O>days</O>,
	},

	"7e71a5fa8f38": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vælg</O>,
		"de": () => <O>Choose</O>,
		"en": () => <O>Choose</O>,
		"no": () => <O>Choose</O>,
		"sv": () => <O>Choose</O>,
	},

	"122b7cddec5e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Datatilsynet</O>,
		"de": () => <O>Datatilsynet</O>,
		"en": () => <O>Datatilsynet</O>,
		"no": () => <O>Datatilsynet</O>,
		"sv": () => <O>Datatilsynet</O>,
	},

	"2975d0c98900": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Gem dette link et sikkert sted.</O>,
		"de": () => <O>Save this link somewhere safe.</O>,
		"en": () => <O>Save this link somewhere safe.</O>,
		"no": () => <O>Save this link somewhere safe.</O>,
		"sv": () => <O>Save this link somewhere safe.</O>,
	},

	"153bb4b733f8": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Hvis du mister det, har du ingen måde at komme tilbage til din sag på.</O>,
		"de": () => <O>If you loose it, you have no way to get back to your case.</O>,
		"en": () => <O>If you loose it, you have no way to get back to your case.</O>,
		"no": () => <O>If you loose it, you have no way to get back to your case.</O>,
		"sv": () => <O>If you loose it, you have no way to get back to your case.</O>,
	},

	"c51a10ada455": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Jeg godkender hermed, at jeg er indforstået med ovenstående.</O>,
		"de": () => <O>I hereby approve that this case may be handed over to the relevant authority</O>,
		"en": () => <O>I hereby approve that this case may be handed over to the relevant authority</O>,
		"no": () => <O>I hereby approve that this case may be handed over to the relevant authority</O>,
		"sv": () => <O>I hereby approve that this case may be handed over to the relevant authority</O>,
	},

	"772dddb12644": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O> Rapporter et problem</O>,
		"de": () => <O>Report an issue</O>,
		"en": () => <O>Report an issue</O>,
		"no": () => <O>Report an issue</O>,
		"sv": () => <O>Report an issue</O>,
	},

	"d2db2b4e27f5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
				                                        Her kan du afgive oplysninger om kritisable forhold hos
				                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Here you can submit information about objectionable circumstances if you are an employee of or business
                                        partner for
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Here you can submit information about objectionable circumstances if you are an employee of or business
                                        partner for
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Here you can submit information about objectionable circumstances if you are an employee of or business
                                        partner for
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Here you can submit information about objectionable circumstances if you are an employee of or business
                                        partner for
                                </O>
                        );
                },
	},

	"c7b252975c91": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
				                                        Inden du indsender information, er det vigtigt, at du har gjort dig bekendt med, hvilke forhold der kan indberettes, som beskrevet på vores hjemmeside, samt at du evt. læser Justitsministeriets vejledning på området. Her kan du f.eks. finde information om, hvad der er omfattet af whistleblowerordningen, hvordan din information håndteres, og hvilke rettigheder du har som whistleblower. Du kan finde vejledningen på Justitsministeriets hjemmeside.
				                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Before you submit information, it is important that you have familiarized yourself with what can be reported
                                        on, as described on our website and that you read the Ministry of Justice's guidance in the area. Here you
                                        can e.g. find information about what is covered by the whistleblower scheme, how your information is handled
                                        and what rights you have as a whistleblower. You can find the guidance on the website of the Ministry of
                                        Justice.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Before you submit information, it is important that you have familiarized yourself with what can be reported
                                        on, as described on our website and that you read the Ministry of Justice's guidance in the area. Here you
                                        can e.g. find information about what is covered by the whistleblower scheme, how your information is handled
                                        and what rights you have as a whistleblower. You can find the guidance on the website of the Ministry of
                                        Justice.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Before you submit information, it is important that you have familiarized yourself with what can be reported
                                        on, as described on our website and that you read the Ministry of Justice's guidance in the area. Here you
                                        can e.g. find information about what is covered by the whistleblower scheme, how your information is handled
                                        and what rights you have as a whistleblower. You can find the guidance on the website of the Ministry of
                                        Justice.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Before you submit information, it is important that you have familiarized yourself with what can be reported
                                        on, as described on our website and that you read the Ministry of Justice's guidance in the area. Here you
                                        can e.g. find information about what is covered by the whistleblower scheme, how your information is handled
                                        and what rights you have as a whistleblower. You can find the guidance on the website of the Ministry of
                                        Justice.
                                </O>
                        );
                },
	},

	"2ddaad42dd2d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
				                                        Vi logger ikke oplysninger, der kan bruges til at spore dig, når du indsender en indberetning. Ønsker du at være anonym og beskytte din anonymitet, skal du f.eks. vær opmærksom på, at du skal undlade at oplyse dit navn eller andre personhenførbare oplysninger, at filer såsom dokumenter og billeder kan indeholde metadata, der kan betyde, at din anonymitet kompromitteres. Når du har indsendt indberetningen, modtager du en kvittering (hvis din indberetning er fortrolig), og du vil hurtigst muligt blive kontaktet via systemet. Er din henvendelse mere presserende end som så, bør du bruge andre kanaler, f.eks. politiet, hvis der fx er tale om akutte kriminelle forhold.
				                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        We do not log information that can be used to track you when you click Submit a report. If you wish to be
                                        anonymous and to protect your anonymity, you must e.g. be aware that you must refrain from giving your name
                                        or other personally identifiable information, that files such as documents and images may contain metadata
                                        that could mean that your anonymity is compromised, that you do not access the portal via the link on one of
                                        the authorities' websites, but instead enter the web address https://bm-dep.sit-wb.dk in a blank browser and
                                        that you must refrain from using a computer that is on an authority's network.
                                        When you have submitted the report, you will receive a receipt, and you will be contacted via the system as
                                        soon as possible. If your inquiry is more urgent than that, you should use other channels, e.g. the police,
                                        if criminal matters are involved.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        We do not log information that can be used to track you when you click Submit a report. If you wish to be
                                        anonymous and to protect your anonymity, you must e.g. be aware that you must refrain from giving your name
                                        or other personally identifiable information, that files such as documents and images may contain metadata
                                        that could mean that your anonymity is compromised, that you do not access the portal via the link on one of
                                        the authorities' websites, but instead enter the web address https://bm-dep.sit-wb.dk in a blank browser and
                                        that you must refrain from using a computer that is on an authority's network.
                                        When you have submitted the report, you will receive a receipt, and you will be contacted via the system as
                                        soon as possible. If your inquiry is more urgent than that, you should use other channels, e.g. the police,
                                        if criminal matters are involved.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        We do not log information that can be used to track you when you click Submit a report. If you wish to be
                                        anonymous and to protect your anonymity, you must e.g. be aware that you must refrain from giving your name
                                        or other personally identifiable information, that files such as documents and images may contain metadata
                                        that could mean that your anonymity is compromised, that you do not access the portal via the link on one of
                                        the authorities' websites, but instead enter the web address https://bm-dep.sit-wb.dk in a blank browser and
                                        that you must refrain from using a computer that is on an authority's network.
                                        When you have submitted the report, you will receive a receipt, and you will be contacted via the system as
                                        soon as possible. If your inquiry is more urgent than that, you should use other channels, e.g. the police,
                                        if criminal matters are involved.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        We do not log information that can be used to track you when you click Submit a report. If you wish to be
                                        anonymous and to protect your anonymity, you must e.g. be aware that you must refrain from giving your name
                                        or other personally identifiable information, that files such as documents and images may contain metadata
                                        that could mean that your anonymity is compromised, that you do not access the portal via the link on one of
                                        the authorities' websites, but instead enter the web address https://bm-dep.sit-wb.dk in a blank browser and
                                        that you must refrain from using a computer that is on an authority's network.
                                        When you have submitted the report, you will receive a receipt, and you will be contacted via the system as
                                        soon as possible. If your inquiry is more urgent than that, you should use other channels, e.g. the police,
                                        if criminal matters are involved.
                                </O>
                        );
                },
	},

	"3c896158dd17": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Fortsæt</O>,
		"de": () => <O>Continue</O>,
		"en": () => <O>Continue</O>,
		"no": () => <O>Continue</O>,
		"sv": () => <O>Continue</O>,
	},

	"43cef96ab062": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Udfyld venligst kontaktoplysningerne, så sagsbehandleren kan identificere dig, så du kan sikre dine whistleblowerrettigheder.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Please fill out contact information so the recipient can reach out.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Please fill out contact information so the recipient can reach out.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Please fill out contact information so the recipient can reach out.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Please fill out contact information so the recipient can reach out.
                                </O>
                        );
                },
	},

	"90d44c7db5b5": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>navn</O>,
		"de": () => <O>name</O>,
		"en": () => <O>name</O>,
		"no": () => <O>name</O>,
		"sv": () => <O>name</O>,
	},

	"8bd66e1d8875": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>kaldenavn som indberetteren/whistlebloweren ser</O>,
		"de": () => <O>screen name</O>,
		"en": () => <O>screen name</O>,
		"no": () => <O>screen name</O>,
		"sv": () => <O>screen name</O>,
	},

	"8df05c5cdfd4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>e-mail</O>,
		"de": () => <O>email</O>,
		"en": () => <O>email</O>,
		"no": () => <O>email</O>,
		"sv": () => <O>email</O>,
	},

	"575c861e082f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Step 1/2</O>,
		"de": () => <O>Step 1/2</O>,
		"en": () => <O>Step 1/2</O>,
		"no": () => <O>Step 1/2</O>,
		"sv": () => <O>Step 1/2</O>,
	},

	"4cf1887ac701": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Vælg om du vil være anonym eller fortrolig. Efter indsendelse af din indberetning, vil du få tilsendt et link, hvor du altid kan tjekke, hvordan sagen udvikler sig.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        This is an 100% anonymous action. After submitting you will get an anonymous link where you always can check how the case is progressing.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        This is an 100% anonymous action. After submitting you will get an anonymous link where you always can check how the case is progressing.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        This is an 100% anonymous action. After submitting you will get an anonymous link where you always can check how the case is progressing.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        This is an 100% anonymous action. After submitting you will get an anonymous link where you always can check how the case is progressing.
                                </O>
                        );
                },
	},

	"da6b7097fa30": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Anonym</O>,
		"de": () => <O>Anonymous</O>,
		"en": () => <O>Anonymous</O>,
		"no": () => <O>Anonymous</O>,
		"sv": () => <O>Anonymous</O>,
	},

	"7922a72d9601": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Fortrolig</O>,
		"de": () => <O>Non-anonymous</O>,
		"en": () => <O>Non-anonymous</O>,
		"no": () => <O>Non-anonymous</O>,
		"sv": () => <O>Non-anonymous</O>,
	},

	"e15fc1226645": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        Din administration eller andre i din organisation vil ikke se din indberetning. Det er kun den behandler, som du vælger på næste side, der vil læse din indberetning. Husk, at anonyme indsendelser ikke garanterer håndtering eller beskyttelse efter whistleblowerreglerne. Alle dine whistleblower-rettigheder er kun garanteret i fortrolig tilstand.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        Your administration or others in
                                        your organization will not see your text. Remember anonymous entries are not guaranteed handling and
                                        all your whistleblower rights are only guaranteed in confidential mode.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        Your administration or others in
                                        your organization will not see your text. Remember anonymous entries are not guaranteed handling and
                                        all your whistleblower rights are only guaranteed in confidential mode.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        Your administration or others in
                                        your organization will not see your text. Remember anonymous entries are not guaranteed handling and
                                        all your whistleblower rights are only guaranteed in confidential mode.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        Your administration or others in
                                        your organization will not see your text. Remember anonymous entries are not guaranteed handling and
                                        all your whistleblower rights are only guaranteed in confidential mode.
                                </O>
                        );
                },
	},

	"e7f6f607dde4": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Fortrolig</O>,
		"de": () => <O>Non Anonymous</O>,
		"en": () => <O>Non Anonymous</O>,
		"no": () => <O>Non Anonymous</O>,
		"sv": () => <O>Non Anonymous</O>,
	},

	"6a77c5632f65": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => {
                        return (
                                <O>
                                        En fortrolig indsendelse vil blive behandlet med diskretion, og kun de tildelte sagsbehandlere vil kende din identitet. Fortrolig tilstand sikrer dine rettigheder som whistleblower.
                                </O>
                        );
                },
		"de": () => {
                        return (
                                <O>
                                        A confidential entry will be treated with discretion, and only the assigned caseworkers will know your
                                        identity. Confidential mode ensures your rights as a whistleblower.
                                </O>
                        );
                },
		"en": () => {
                        return (
                                <O>
                                        A confidential entry will be treated with discretion, and only the assigned caseworkers will know your
                                        identity. Confidential mode ensures your rights as a whistleblower.
                                </O>
                        );
                },
		"no": () => {
                        return (
                                <O>
                                        A confidential entry will be treated with discretion, and only the assigned caseworkers will know your
                                        identity. Confidential mode ensures your rights as a whistleblower.
                                </O>
                        );
                },
		"sv": () => {
                        return (
                                <O>
                                        A confidential entry will be treated with discretion, and only the assigned caseworkers will know your
                                        identity. Confidential mode ensures your rights as a whistleblower.
                                </O>
                        );
                },
	},

	"711f26c2f742": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Forbliv logget på</O>,
		"de": () => <O>Remember me</O>,
		"en": () => <O>Remember me</O>,
		"no": () => <O>Remember me</O>,
		"sv": () => <O>Remember me</O>,
	},

	"a6bea166c3cd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Log in</O>,
		"de": () => <O>Sign&nbsp;in</O>,
		"en": () => <O>Sign&nbsp;in</O>,
		"no": () => <O>Sign&nbsp;in</O>,
		"sv": () => <O>Sign&nbsp;in</O>,
	},

	"e0eff7d433db": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Har du ikke en bruger?</O>,
		"de": () => <O>Don't have an account?</O>,
		"en": () => <O>Don't have an account?</O>,
		"no": () => <O>Don't have an account?</O>,
		"sv": () => <O>Don't have an account?</O>,
	},

	"42d1a4bfbc99": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Glemt din adgangskode?</O>,
		"de": () => <O>Forgot password?</O>,
		"en": () => <O>Forgot password?</O>,
		"no": () => <O>Forgot password?</O>,
		"sv": () => <O>Forgot password?</O>,
	},

	"3badedd3437a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Login med din e-mail og adgangskode</O>,
		"de": () => <O>Login with your email and your password</O>,
		"en": () => <O>Login with your email and your password</O>,
		"no": () => <O>Login with your email and your password</O>,
		"sv": () => <O>Login with your email and your password</O>,
	},

	"a1fb1cb802e1": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vælg modtager af indberetningen</O>,
		"de": () => <O>Choose recipient</O>,
		"en": () => <O>Choose recipient</O>,
		"no": () => <O>Choose recipient</O>,
		"sv": () => <O>Choose recipient</O>,
	},

	"c006c3019fdd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>DEL</O>,
		"de": () => <O>SHARE</O>,
		"en": () => <O>SHARE</O>,
		"no": () => <O>SHARE</O>,
		"sv": () => <O>SHARE</O>,
	},

	"fbfb5abbc43c": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Premium</O>,
		"de": () => <O>Premium</O>,
		"en": () => <O>Premium</O>,
		"no": () => <O>Premium</O>,
		"sv": () => <O>Premium</O>,
	},

	"7532d9ef78a0": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Compliance</O>,
		"de": () => <O>Compliance</O>,
		"en": () => <O>Compliance</O>,
		"no": () => <O>Compliance</O>,
		"sv": () => <O>Compliance</O>,
	},

	"0b20e2a6226b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>1 time</O>,
		"de": () => <O>1 hour</O>,
		"en": () => <O>1 hour</O>,
		"no": () => <O>1 hour</O>,
		"sv": () => <O>1 hour</O>,
	},

	"61784b2f5819": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>1 dag</O>,
		"de": () => <O>1 day</O>,
		"en": () => <O>1 day</O>,
		"no": () => <O>1 day</O>,
		"sv": () => <O>1 day</O>,
	},

	"aa3b7a6fdfdb": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>1 uge</O>,
		"de": () => <O>1 week</O>,
		"en": () => <O>1 week</O>,
		"no": () => <O>1 week</O>,
		"sv": () => <O>1 week</O>,
	},

	"09c86da4f52f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Anfør hvor længe linket skal være aktivt</O>,
		"de": () => <O>Set access duration</O>,
		"en": () => <O>Set access duration</O>,
		"no": () => <O>Set access duration</O>,
		"sv": () => <O>Set access duration</O>,
	},

	"6289d5debfad": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Her er linket du kan sende til </O>,
		"de": () => <O>Here is the link you can send to </O>,
		"en": () => <O>Here is the link you can send to </O>,
		"no": () => <O>Here is the link you can send to </O>,
		"sv": () => <O>Here is the link you can send to </O>,
	},

	"8bab4fb05176": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Vælg metoden for to-faktor-godkendelse</O>,
		"de": () => <O>Chose the method of two factor verification</O>,
		"en": () => <O>Chose the method of two factor verification</O>,
		"no": () => <O>Chose the method of two factor verification</O>,
		"sv": () => <O>Chose the method of two factor verification</O>,
	},

	"a864dbffc25e": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Telefonnummer</O>,
		"de": () => <O>Phone</O>,
		"en": () => <O>Phone</O>,
		"no": () => <O>Phone</O>,
		"sv": () => <O>Phone</O>,
	},

	"9777f2ecf841": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Ønsker et møde</O>,
		"de": () => <O>Wanting a meeting</O>,
		"en": () => <O>Wanting a meeting</O>,
		"no": () => <O>Wanting a meeting</O>,
		"sv": () => <O>Wanting a meeting</O>,
	},

	"55f0bf513f6b": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Indberetteren ønsker et møde</O>,
		"de": () => <O>The entry reporter whishes a meeting</O>,
		"en": () => <O>The entry reporter whishes a meeting</O>,
		"no": () => <O>The entry reporter whishes a meeting</O>,
		"sv": () => <O>The entry reporter whishes a meeting</O>,
	},

	"ea5e7d2d2a4f": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Din besked</O>,
		"de": () => <O>Your message</O>,
		"en": () => <O>Your message</O>,
		"no": () => <O>Your message</O>,
		"sv": () => <O>Your message</O>,
	},

	"767372d1aef7": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Send besked</O>,
		"de": () => <O>Send message</O>,
		"en": () => <O>Send message</O>,
		"no": () => <O>Send message</O>,
		"sv": () => <O>Send message</O>,
	},

	"b53c6fa6bd9d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Slet Indberetning</O>,
		"de": () => <O>Delete Entry</O>,
		"en": () => <O>Delete Entry</O>,
		"no": () => <O>Delete Entry</O>,
		"sv": () => <O>Delete Entry</O>,
	},

	"8e05302b1520": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Er du sikker på, at du vil slette alt indhold i indberetningen? Denne handling kan ikke fortrydes.</O>,
		"de": () => <O>Are you sure you want to delete all content of the entry? This action cannot be undone.</O>,
		"en": () => <O>Are you sure you want to delete all content of the entry? This action cannot be undone.</O>,
		"no": () => <O>Are you sure you want to delete all content of the entry? This action cannot be undone.</O>,
		"sv": () => <O>Are you sure you want to delete all content of the entry? This action cannot be undone.</O>,
	},

	"ce9b41b17abd": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>skjul log</O>,
		"de": () => <O>hide logs</O>,
		"en": () => <O>hide logs</O>,
		"no": () => <O>hide logs</O>,
		"sv": () => <O>hide logs</O>,
	},

	"b970d9e4dc06": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Tilføj en note</O>,
		"de": () => <O>Add a comment</O>,
		"en": () => <O>Add a comment</O>,
		"no": () => <O>Add a comment</O>,
		"sv": () => <O>Add a comment</O>,
	},

	"877992c4896a": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>skriv besked</O>,
		"de": () => <O>write message</O>,
		"en": () => <O>write message</O>,
		"no": () => <O>write message</O>,
		"sv": () => <O>write message</O>,
	},

	"20a9e57d4039": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Beskeden skal ses af indberetteren</O>,
		"de": () => <O>Message can be seen by whistle creator</O>,
		"en": () => <O>Message can be seen by whistle creator</O>,
		"no": () => <O>Message can be seen by whistle creator</O>,
		"sv": () => <O>Message can be seen by whistle creator</O>,
	},

	"46b4f036c66d": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>Send</O>,
		"de": () => <O>Send</O>,
		"en": () => <O>Send</O>,
		"no": () => <O>Send</O>,
		"sv": () => <O>Send</O>,
	},

	"1848882b2824": {
		"_new": true, // FIXME remove this line when translation is done
		"da": () => <O>vis log</O>,
		"de": () => <O>show logs</O>,
		"en": () => <O>show logs</O>,
		"no": () => <O>show logs</O>,
		"sv": () => <O>show logs</O>,
	},
}
